if (window.addEventListener && void 0 === mmAppLoaded) {
    var mmAppLoaded = !0, undo = [], redo = [], action = "", tempMenuObject = {}, changedMenu = !1, submenuToggled = !1, changingPage = !1, saving = !1, panelOpened = !1, verticalMenuMaxWidth = 1e4, selectedMenu, mmClicked, touched, burgerIcon, disableOnClick = !1, globalTouch = !0, onClickOnlyReinit = !1, disableOnScroll = !1, mobileMenuMilliseconds = 350, mmMenuUls = [], submenuSizes = {}, submenuDirections = {}, submenuColumns = {}, customHeaderOffset = !1, fontSize = 0, storeUlCount = 0, storeNavCount = 0, loadMegaMenuTries = 100, customMenuUls, defaultFontSelected = !1, forceMobile = !1, previewPanelLoaded = !1, allowMainMenuRecalibration = !0, readyStateCheckInterval, disableThemeScript = !1, mmApplyOnce = !1, initializedSchema = !1, mmSetSmBoundriesOnReinit = !1, mmHorizontalMenus = !1, mmVerticalMenus = !1, livIconsOptions = {}, livIconsOptionsCache = [], mmDisableVisibleCheck = !1, mmDisableResizeHandler = !1, mmDomChangesInterval = 200, mmMobileMenuTreeOffsetLeft = 25, mmInitBuddhaMegaMenuInterval = 200, mmInitBuddhaMegaMenuTimeout = 10, mmLoadWhenReadyStateIs = "interactive,complete", mmAtcPopupSuccess = "JUST ADDED TO YOUR CART", mmAtcPopupOutOfStock = "OUT OF STOCK", mmAtcPopupViewCart = "VIEW CART", mmMenuOverflowAuto = !1, mmClickToggle = 0, mmMenuOpenDelay = 0;
    mmTranslateLinksForce = !1,
    mmWireSlices = [1],
    schemaDesignJSON = [];
    var mmAddStyle = function(e, t) {
        const n = document.createElement("style");
        if (n.textContent = e,
        void 0 !== t) {
            n.id = t;
            var m = document.getElementById(t);
            m && m.parentNode.removeChild(m)
        }
        (document.head || document.getElementsByTagName("head")[0]).appendChild(n)
    }
      , mmAddLink = function(e, t) {
        const n = document.createElement("link");
        if (n.href = e,
        n.type = "text/css",
        n.rel = "stylesheet",
        void 0 !== t) {
            n.id = t;
            var m = document.getElementById(t);
            m && m.parentNode.removeChild(m)
        }
        document.head.appendChild(n)
    }
      , mmAddClasses = function(e, t) {
        try {
            if (t && "string" == typeof t)
                for (var n = t.replace(/\s+/g, " ").split(" "), m = 0; m < n.length; m++) {
                    "" != (o = n[m].trim()) && e.classList.add(o)
                }
        } catch (e) {
            var o = new Error(e.message + " |" + t);
            mmErrorLog(o)
        }
    }
      , mmForEach = function(e, t, n, m) {
        for (var o = e.querySelectorAll(t), a = 0; a < o.length && -1 != n(o[a]); a++)
            ;
        if (void 0 !== m)
            return o
    }
      , mmForEachChild = function(e, t, n) {
        var m = e.children;
        if (m)
            for (var o = 0; o < m.length; o++)
                m[o].nodeName == t && n(m[o])
    }
      , mmGetChildren = function(e, t, n) {
        var m, o, a = e.id;
        if (e.parentNode) {
            var i = "#" + (e.id = a || "mmGC_TID_1234") + " > ";
            t = i + (t + "").replace(",", "," + i, "g"),
            m = e.parentNode
        } else
            m = e;
        return o = 1 == n ? m.querySelector(t) : m.querySelectorAll(t),
        !a && e.parentNode && e.removeAttribute("id"),
        o
    }
      , mmNot = function(e, t, n) {
        for (var m = [], o = 0; o < e.length; o++)
            e[o].matches(t) || (void 0 === n || 0 == n || 1 == n && !e[o].querySelector(t)) && m.push(e[o]);
        return m
    }
      , mmParents = function(e, t) {
        var n = []
          , m = e;
        if (!m || !m.parentNode)
            return n;
        for (; m.parentNode != document; )
            void 0 !== t && m.parentNode.tagName != t || n.push(m.parentNode),
            m = m.parentNode;
        return n
    }
      , mmElementIndex = function(e) {
        for (var t = 0; null != (e = e.previousElementSibling); )
            ++t;
        return t
    }
      , mmIsVisible = function(e) {
        return !!e && (e.offsetHeight > 0 || e.offsetWidth > 0 || "contents" == e.style.display && e.children && e.children[0].offsetParent || window.self !== window.top && "contents" == window.getComputedStyle(e).getPropertyValue("display") && e.children && e.children[0].offsetParent)
    }
      , mmRemove = function(e) {
        for (var t = document.querySelectorAll(e), n = 0; n < t.length; n++)
            t[n].parentNode.removeChild(t[n])
    }
      , mmSetFontStyle = function(e) {
        mmAddStyle(".horizontal-mega-menu .buddha-menu-item ul.mm-submenu,            .horizontal-mega-menu .buddha-menu-item ul.mm-submenu li a,            .horizontal-mega-menu .buddha-menu-item ul.mm-submenu li .mm-title,            .horizontal-mega-menu .buddha-menu-item ul.mm-submenu.simple>li .mm-list-name>span,            .vertical-mega-menu .buddha-menu-item ul.mm-submenu,            .vertical-mega-menu .buddha-menu-item ul.mm-submenu li a,            .vertical-mega-menu .buddha-menu-item ul.mm-submenu li .mm-title,            .buddha-menu-item ul.mm-submenu a,            .buddha-menu-item ul.mm-submenu li.mm-contact-column .mm-contact-content,             .buddha-menu-item ul.mm-submenu li.mm-contact-column .mm-contact-content button,             .buddha-menu-item ul.mm-submenu li.mm-contact-column .mm-contact-content .mm-head,             .buddha-menu-item ul.mm-submenu li.mm-contact-column .mm-contact-content span,             .buddha-menu-item ul.mm-submenu li.mm-contact-column .mm-contact-content b,             .buddha-menu-item ul.mm-submenu li.mm-contact-column .mm-contact-content textarea,             .buddha-menu-item ul.mm-submenu li.mm-contact-column .mm-contact-content input {" + e + "}")
    }
      , mmSupportsPassive = !1;
    try {
        var opts = Object.defineProperty({}, "passive", {
            get: function() {
                mmSupportsPassive = !0
            }
        });
        window.addEventListener("testPassive", null, opts),
        window.removeEventListener("testPassive", null, opts)
    } catch (e) {}
    var mmNumErrors = 0
      , mmErrorLog = function(e) {
        for (var t = !1, n = !1, m = 0; m < mmSchemaDesignJSON.length; m++)
            "menu-select" == mmSchemaDesignJSON[m].action && "none" != mmSchemaDesignJSON[m].value && (t = mmSchemaDesignJSON[m].value);
        if (-1 == navigator.userAgent.indexOf("Mediapartners-Google") && -1 == navigator.userAgent.indexOf("Yandex") || (n = !0),
        mmNumErrors++,
        t && !n && mmNumErrors <= 1) {
            var o = new XMLHttpRequest;
            o.open("POST", "https://notify.bugsnag.com/"),
            o.setRequestHeader("Content-Type", "application/json"),
            o.setRequestHeader("Bugsnag-Api-Key", "b1d0f3de79a0970e706491de768a5c2e"),
            o.setRequestHeader("Bugsnag-Payload-Version", "5"),
            o.onreadystatechange = function() {
                4 === this.readyState && (console.log("Status:", this.status),
                console.log("Headers:", this.getAllResponseHeaders()),
                console.log("Body:", this.responseText))
            }
            ;
            var a = {
                apiKey: "b1d0f3de79a0970e706491de768a5c2e",
                payloadVersion: "5",
                notifier: {
                    name: "Bugsnag Ruby",
                    version: "1.0.11",
                    url: "https://github.com/bugsnag/bugsnag-ruby",
                    dependencies: [{
                        name: "Bugsnag Android",
                        version: "2.1.10",
                        url: "https://github.com/bugsnag/bugsnag-android"
                    }]
                },
                events: [{
                    exceptions: [{
                        errorClass: "buddha-megamenu-V2.js",
                        message: e.message,
                        stacktrace: [{
                            file: window.location.hostname,
                            code: {
                                0: window.location.href,
                                1: e.stack
                            }
                        }]
                    }],
                    unhandled: !1,
                    device: {
                        browserName: navigator.userAgent
                    }
                }]
            };
            throw o.send(JSON.stringify(a)),
            e
        }
    }
      , LZW_decompress = function(e) {
        "use strict";
        var t, n, m, o, a = [], i = "", r = 256;
        for (t = 0; t < 256; t += 1)
            a[t] = String.fromCharCode(t);
        for (m = n = String.fromCharCode(e[0]),
        t = 1; t < e.length; t += 1) {
            if (a[o = e[t]])
                i = a[o];
            else {
                if (o !== r)
                    return null;
                i = n + n.charAt(0)
            }
            m += i,
            a[r++] = n + i.charAt(0),
            n = i
        }
        return m
    };
    Element.prototype.matches || (Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function(e) {
        return !1
    }
    ),
    Element.prototype.closest || (Element.prototype.closest = function(e) {
        var t = this;
        do {
            if (Element.prototype.matches.call(t, e))
                return t;
            t = t.parentElement || t.parentNode
        } while (null !== t && 1 === t.nodeType);
        return null
    }
    ),
    Array.from || (Array.from = function(e) {
        "use strict";
        return [].slice.call(e)
    }
    );
    var loadBuddhaMegaMenu = function() {
        readyStateCheckInterval = setInterval(initBuddhaMegaMenu, mmInitBuddhaMegaMenuInterval),
        setTimeout((function() {
            clearInterval(readyStateCheckInterval)
        }
        ), 35e3),
        mmAddStyle(generateMobileMenuColors("#017b86", !0), "buddhaInitialMobileMenuColors"),
        window.self !== window.top && ("loading" !== document.readyState ? initSchema() : window.addEventListener("load", initSchema),
        setTimeout((function() {
            initSchema()
        }
        ), 5e3)),
        0 != mmInitBuddhaMegaMenuTimeout && setTimeout(initBuddhaMegaMenu, mmInitBuddhaMegaMenuTimeout)
    }, mmStaticMenuFn = function() {
        try {
            mmForEach(document, ".horizontal-mega-menu>.buddha-menu-item>.mm-submenu", (function(e) {
                if (parseInt(window.getComputedStyle(e).getPropertyValue("top")) > 0) {
                    var t = e.parentNode;
                    if (e.matches(".mm-submenu.simple,.mm-submenu.tabbed")) {
                        var n = !1;
                        if (0 == mmMenuOverflowAuto)
                            for (var m = mmParents(t.parentNode), o = 0; o < m.length; o++) {
                                var a = window.getComputedStyle(m[o]).getPropertyValue("position");
                                "fixed" != a && "sticky" != a || (n = !0)
                            }
                        else
                            n = !0;
                        var i = e.getBoundingClientRect()
                          , r = parseInt(i.top)
                          , u = 2e3;
                        n ? u = window.innerHeight - r : document.documentElement.offsetHeight <= window.innerHeight + 100 && document.documentElement.offsetHeight > 400 && (u = document.documentElement.offsetHeight - 150),
                        i.height >= u - 30 ? (e.style.maxHeight = u + "px",
                        e.style.overflow = "scroll",
                        e.style.overflowX = "hidden",
                        e.style.clip = "unset",
                        e.style.setProperty("box-shadow", "0 10px 20px rgba(0,0,0,.1)", "important")) : (e.style.maxHeight = "none",
                        e.style.overflow = "hidden",
                        e.style.removeProperty("clip"),
                        e.style.removeProperty("box-shadow"))
                    }
                }
            }
            ))
        } catch (e) {
            mmErrorLog(e)
        }
    }, 
    mmInitVarsWaitTime = 0, 
    initBuddhaMegaMenu = function() {
        try {
            if ("undefined" == typeof linkLists || "undefined" == typeof mmWireframe || void 0 === mmWireframe.html || window.self === window.top && (window.self !== window.top || -1 == mmLoadWhenReadyStateIs.indexOf(document.readyState))){
                return !1;
            }
                
            mmWireframe = "1" == mmWireframeCompression ? decodeURIComponent(LZW_decompress(mmWireframe.html.split(",").map(Number))) : mmWireframe.html;
            mmWireframe = mmWireframe.replace(new RegExp('<div id="bsWidget">',"g"), bestSellersHTML);
            mmWireframe = mmWireframe.replace(new RegExp('<div id="npWidget">',"g"), newestProductsHTML);
            console.log("~~~~~~~~~~~~~~",mmWireframe,"~~~~~~~~~~~~~~");
            for (var e = Object.keys(productImageAndPrice), t = 0; t < e.length; t++) {
                var n = -1 != productImageAndPrice[e[t]][2].indexOf("mega-menu-sold_out") ? "mm-sold-out" : "";
                mmWireframe = mmWireframe.replace(new RegExp('<div class="mega-menu-prices get-mega-menu-prices" data-id="' + e[t] + '"></div>',"g"), '<div class="mega-menu-prices ' + n + '">' + productImageAndPrice[e[t]][2] + "</div>")
            }
            if (void 0 !== mmSchemaTranslation.menuStrings && 1 == mmSchemaTranslation.enabled) {
                var m = mmSchemaTranslation.menuStrings[mmShopLocale];
                if (void 0 !== m)
                    for (var o in m) {
                        var a = m[o].trim();
                        o = o.trim().replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&"),
                        "" != a && (mmWireframe = mmWireframe.replace(new RegExp('"' + o + '"',"g"), '"' + a + '"'),
                        mmWireframe = mmWireframe.replace(new RegExp(">" + o + "<","g"), ">" + a + "<"),
                        mmWireframe = mmWireframe.replace(new RegExp(">" + o + "&nbsp;<","g"), ">" + a + "<"))
                    }
                if (void 0 !== (m = mmSchemaTranslation.additional[mmShopLocale])) {
                    void 0 !== m["Add to cart"] && "" !== m["Add to cart"] && (mmWireframe = mmWireframe.replace(new RegExp(">Add to cart<","g"), ">" + m["Add to cart"] + "<")),
                    void 0 !== m["Sold out"] && "" !== m["Sold out"] && (mmWireframe = mmWireframe.replace(new RegExp(">Sold out<","g"), ">" + m["Sold out"] + "<")),
                    void 0 !== m.Title && "" !== m.Title && (mmAtcPopupSuccess = m.Title),
                    void 0 !== m["Out of Stock Title"] && "" !== m["Out of Stock Title"] && (mmAtcPopupOutOfStock = m["Out of Stock Title"]),
                    void 0 !== m["View Cart"] && "" !== m["View Cart"] && (mmAtcPopupViewCart = m["View Cart"]),
                    void 0 !== m.NEW && "" !== m.NEW && (mmWireframe = mmWireframe.replace(new RegExp('"mm-label new">NEW<',"g"), '"mm-label new">' + m.NEW + "<")),
                    void 0 !== m.HOT && "" !== m.HOT && (mmWireframe = mmWireframe.replace(new RegExp('"mm-label hot">HOT<',"g"), '"mm-label hot">' + m.HOT + "<")),
                    void 0 !== m.SALE && "" !== m.SALE && (mmWireframe = mmWireframe.replace(new RegExp('"mm-label sale">SALE<',"g"), '"mm-label sale">' + m.SALE + "<")),
                    void 0 !== m["Business Info"] && "" !== m["Business Info"] && (mmWireframe = mmWireframe.replace(new RegExp('<div class="mm-head">Business Info</div>',"g"), '<div class="mm-head">' + m["Business Info"] + "</div>")),
                    void 0 !== m.Info && "" !== m.Info && (mmWireframe = mmWireframe.replace(new RegExp('<div class="mm-desc">.*?</div>',"g"), '<div class="mm-desc">' + m.Info + "</div>")),
                    void 0 !== m.Address && "" !== m.Address && (mmWireframe = mmWireframe.replace(new RegExp('<div class="mm-address">.*?</div>',"g"), '<div class="mm-address"><a href="http://maps.google.com/?q=' + m.Address + '"target="_blank">' + m.Address + "</a></div>"));
                    var i = document.querySelector("#mmContactFormHTML");
                    i && (void 0 !== m.Name && "" !== m.Name && mmForEach(i, ".contact-form .mm-name input", (function(e) {
                        e.setAttribute("placeholder", m.Name)
                    }
                    )),
                    void 0 !== m.Email && "" !== m.Email && mmForEach(i, ".contact-form .mm-email input", (function(e) {
                        e.setAttribute("placeholder", m.Email)
                    }
                    )),
                    void 0 !== m.Message && "" !== m.Message && mmForEach(i, ".contact-form .mm-message textarea", (function(e) {
                        e.setAttribute("placeholder", m.Message)
                    }
                    )),
                    void 0 !== m["Send Message"] && "" !== m["Send Message"] && mmForEach(i, ".contact-form .mm-contact-submit", (function(e) {
                        e.innerHTML = m["Send Message"]
                    }
                    )),
                    void 0 !== m["Message Sent Notification"] && "" !== m["Message Sent Notification"] && mmForEach(i, ".successForm.feedback", (function(e) {
                        e.innerHTML = m["Message Sent Notification"]
                    }
                    )))
                }
            }
            if (1 == mmSchemaTranslation.enabled || 1 == mmTranslateLinksForce) {
                var r = window.location.hostname
                  , u = mmShopLocale.split("-")[0];
                if (0 == r.indexOf(u + ".") || -1 != r.indexOf("." + u, r.length - u.length - 1) || "en" == u && -1 != r.indexOf(".co.uk"))
                    ;
                else {
                    var l = mmShopLocaleCollectionsRoute.slice(1, -12);
                    if ("" != l) {
                        mmWireframe = mmWireframe.replace(new RegExp('"/"',"g"), '"/' + l + '"'),
                        mmWireframe = mmWireframe.replace(new RegExp('"/collections',"g"), '"/' + l + "/collections"),
                        mmWireframe = mmWireframe.replace(new RegExp('"/products',"g"), '"/' + l + "/products"),
                        mmWireframe = mmWireframe.replace(new RegExp('"/pages',"g"), '"/' + l + "/pages"),
                        mmWireframe = mmWireframe.replace(new RegExp('"/blogs',"g"), '"/' + l + "/blogs"),
                        mmWireframe = mmWireframe.replace(new RegExp(buddhaMegaMenuShop + "/collections","g"), buddhaMegaMenuShop + "/" + l + "/collections"),
                        mmWireframe = mmWireframe.replace(new RegExp(buddhaMegaMenuShop + "/products","g"), buddhaMegaMenuShop + "/" + l + "/products"),
                        mmWireframe = mmWireframe.replace(new RegExp(buddhaMegaMenuShop + "/pages","g"), buddhaMegaMenuShop + "/" + l + "/pages"),
                        mmWireframe = mmWireframe.replace(new RegExp(buddhaMegaMenuShop + "/blogs","g"), buddhaMegaMenuShop + "/" + l + "/blogs"),
                        mmWireframe = mmWireframe.replace(new RegExp(buddhaMegaMenuShop + "/account","g"), buddhaMegaMenuShop + "/" + l + "/account"),
                        mmWireframe = mmWireframe.replace(new RegExp(buddhaMegaMenuShop + "/policies","g"), buddhaMegaMenuShop + "/" + l + "/policies");
                        var s = window.location.host;
                        mmWireframe = mmWireframe.replace(new RegExp(s + "/collections","g"), s + "/" + l + "/collections"),
                        mmWireframe = mmWireframe.replace(new RegExp(s + "/products","g"), s + "/" + l + "/products"),
                        mmWireframe = mmWireframe.replace(new RegExp(s + "/pages","g"), s + "/" + l + "/pages"),
                        mmWireframe = mmWireframe.replace(new RegExp(s + "/blogs","g"), s + "/" + l + "/blogs"),
                        mmWireframe = mmWireframe.replace(new RegExp(s + "/account","g"), s + "/" + l + "/account"),
                        mmWireframe = mmWireframe.replace(new RegExp(s + "/policies","g"), s + "/" + l + "/policies"),
                        mmForEach(document, ".mm-atc-popup .mm-atc-view-cart", (function(e) {
                            e.setAttribute("href", "/" + l + "/cart")
                        }
                        ))
                    }
                }
            }
            clearInterval(readyStateCheckInterval),
            "undefined" != typeof InstantClick && InstantClick.on("change", (function(e) {
                e || null == document.querySelector(".horizontal-mega-menu,.vertical-mega-menu") && (mmMenuUls = [],
                storeUlCount = 0,
                storeNavCount = 0,
                preloadBuddhaMegaMenu())
            }
            ));
            var c, d = 0, g = setInterval((function() {
                d++,
                "undefined" != typeof mutationExceptions && (mutationExceptions[mutationExceptions.length] = ".buddha-menu-item",
                clearInterval(g)),
                d > 10 && clearInterval(g)
            }), 1e3);
            if ("undefined" != typeof mmCustomerFixesBeforeInit && (!mmFixesUseJquery || mmFixesUseJquery && "function" == typeof jQueryBuddha) && -1 == mmCustomerFixesBeforeInit()){
                return void mmRemove("#mmHideOriginalMenuStyle");
            }
            "undefined" != typeof mmThemeFixesBeforeInit && 0 == disableThemeScript && mmThemeFixesBeforeInit(),
            null == document.querySelector(burgerIcon) && (burgerIcon = ".js-mobile-nav-toggle,.js-drawer-open-left,.js-drawer-open-button-left,#wsnavtoggle,.header__mobile-nav-toggle,#mobileNavBar .menu-toggle,.js-drawer-open-nav,.icon-menu,.js-mobile-menu-icon,.header__mobile__button,.toggle-menu,.slicknav_btn,.Header__Icon,.icon-nav,.site-header__navigation,.mobile-header-controls__menu,.header__icon--menu,.jas-push-menu-btn,.js-slideout-open",
            null == document.querySelector(burgerIcon) && (burgerIcon = "*")),
            mmClickToggle && initClickToggle(),
            initSchema(),
            window.self !== window.top && (mmRemove("#admin_bar_iframe"),
            document.querySelector("html").style.paddingTop = "0px",
            setInterval((function() {
                mmForEach(document, "*", (function(e) {
                    var t = window.getComputedStyle(e)
                      , n = t.getPropertyValue("top")
                      , m = t.getPropertyValue("position");
                    "40px" == n && "fixed" == m && (e.style.top = "0px")
                }
                ))
            }
            ), 1e3));
            var p = window.innerWidth;
            window.addEventListener("resize", (function() {
                try {
                    p == window.innerWidth || mmDisableResizeHandler || (mmForEach(document, ".mm-hovering", (function(e) {
                        e.classList.remove("mm-hovering")
                    }
                    )),
                    clearTimeout(c),
                    c = setTimeout((function() {
                        const e = document.createEvent("Event");
                        e.initEvent("mmWindowResize", !0, !0),
                        document.dispatchEvent(e);
                        var t = !1
                          , n = document.querySelector(".mega-hover");
                        n && (t = n.getAttribute("itemId"));
                        var m = !1;
                        h = document.querySelectorAll("ul").length,
                        b = document.querySelectorAll("nav").length,
                        h -= document.querySelectorAll(".buddha-menu-item ul,.bcsell-list" + mmDomChangeSkipUl).length,
                        storeUlCount == h && storeNavCount == b || (storeUlCount = h,
                        storeNavCount = b,
                        m = !0);
                        for (var o = 0; o < mmMenuUls.length; o++)
                            mmMenuUls[o].querySelectorAll(".buddha-menu-item").length != mmNumMMI && (m = !0);
                        if (m)
                            applyMegaMenu(),
                            applyOnClick();
                        else
                            for (o = 0; o < mmMenuUls.length; o++)
                                reinitMenus(mmMenuUls[o]);
                        t && designPanelOpened(t),
                        panelOpened && null == document.querySelector(".buddha-menu-item.mega-hover") && designPanelOpened(),
                        p = window.innerWidth
                    }
                    ), 300))
                } catch (e) {
                    mmErrorLog(e)
                }
            }
            )),
            disableOnScroll || setInterval(mmStaticMenuFn, 1e3);
            var h = document.querySelectorAll("ul").length
              , b = document.querySelectorAll("nav").length;
            h -= document.querySelectorAll(".buddha-menu-item ul,.bcsell-list" + mmDomChangeSkipUl).length;
            var f = 1;
            storeUlCount == h && storeNavCount == b || (storeUlCount = h,
            storeNavCount = b,
            applyMegaMenu(),
            applyOnClick()),
            clearInterval(y);
            var v, y = setInterval((function() {
                try {
                    if (++f > loadMegaMenuTries && clearInterval(y),
                    h = document.querySelectorAll("ul").length,
                    b = document.querySelectorAll("nav").length,
                    h -= document.querySelectorAll(".buddha-menu-item ul,.bcsell-list" + mmDomChangeSkipUl).length,
                    storeUlCount != h || storeNavCount != b) {
                        if (storeUlCount = h,
                        storeNavCount = b,
                        void 0 !== customMenuUls) {
                            for (var e = 0, t = customMenuUls.split(","), n = 0; n < t.length; n++) {
                                var m = document.querySelector(t[n]);
                                m && m.matches(".vertical-mega-menu,.horizontal-mega-menu") && e++
                            }
                            if (e == t.length)
                                return void clearInterval(y)
                        }
                        applyMegaMenu(),
                        applyOnClick()
                    }
                } catch (e) {
                    mmErrorLog(e)
                }
            }
            ), mmDomChangesInterval);
            document.addEventListener("lazyloaded", (function(e) {
                try {
                    var t = e.target
                      , n = t.closest(".mm-submenu.simple");
                    if (n) {
                        var m = t.closest(".mm-image")
                          , o = t.closest(".mm-image-container");
                        if (m && o) {
                            t.removeAttribute("style"),
                            o.removeAttribute("style"),
                            m.removeAttribute("style"),
                            0 != t.width && 0 != t.height && (t.style.width = t.width + "px",
                            t.style.height = t.height + "px",
                            m.style.height = t.height + "px");
                            var a = m.nextElementSibling;
                            if (a) {
                                var i = a.firstElementChild;
                                i && i.classList.contains("mmHidden") && (i.classList.remove("mmHidden"),
                                i.classList.add("mmShow"))
                            }
                            setTimeout((function() {
                                try {
                                    var e = m.closest("li");
                                    if (e) {
                                        e.getAttribute("image-type") || e.setAttribute("image-type", "fit-high"),
                                        setImageContainerDimensions(e);
                                        var t = n.parentNode
                                          , o = t.closest(".mm-submenu.tabbed")
                                          , a = n.getAttribute("columns");
                                        o && (a = o.getAttribute("columns") - 1),
                                        t && t.parentNode && setSubmenuRowItemsHeight(t, a)
                                    }
                                } catch (e) {
                                    mmErrorLog(e)
                                }
                            }
                            ), 20),
                            clearTimeout(v),
                            v = setTimeout((function() {
                                var e = n.parentNode
                                  , t = e.closest(".mm-submenu.tabbed")
                                  , m = n.getAttribute("columns");
                                t && (m = t.getAttribute("columns") - 1),
                                e.classList.contains("mm-hovering") && slideDownTransition(n),
                                setSubmenuImageAndHeightBoundries(e, m),
                                t && e.matches(".tab-opened") && setTabbedSubmenuBoundries(e)
                            }
                            ), 200)
                        } else
                            t.setAttribute("style", "border-radius: 50%; overflow: hidden;"),
                            t.offsetWidth < 25 && (t.style.display = "none")
                    }
                } catch (e) {
                    mmErrorLog(e)
                }
            }
            ))
        } catch (e) {
            mmErrorLog(e)
        }
    }, mmEvtApplyOnClick = function(e) {
        var t = e.target;
        mmClicked || touched || (mmClicked = !0,
        setTimeout((function() {
            try {
                var e = t.closest(".horizontal-mega-menu")
                  , n = t.closest(".vertical-mega-menu");
                if (!(changingPage || null != t.closest(".buddha-menu-item") || null != e && (null == e || mmIsVisible(e.querySelector(".buddha-menu-item"))) || null != n && (null == n || mmIsVisible(n.querySelector(".buddha-menu-item"))) || void 0 !== t.classList && (void 0 === t.classList || t.classList.contains("stop-mega-menu-reinit")) || null != t.closest(".mm-contact-content"))) {
                    var m = !1
                      , o = document.querySelectorAll("ul").length
                      , a = document.querySelectorAll("nav").length;
                    o -= document.querySelectorAll(".buddha-menu-item ul,.bcsell-list" + mmDomChangeSkipUl).length,
                    storeUlCount == o && storeNavCount == a || (storeUlCount = o,
                    storeNavCount = a,
                    m = !0);
                    for (var i = 0; i < mmMenuUls.length; i++)
                        0 != mmMenuUls[i].isConnected && mmMenuUls[i].querySelectorAll(".buddha-menu-item").length == mmNumMMI || (m = !0);
                    if (onClickOnlyReinit || 0 == m)
                        for (i = 0; i < mmMenuUls.length; i++)
                            reinitMenus(mmMenuUls[i]);
                    else
                        applyMegaMenu();
                    if ("undefined" != typeof DoublyGlobalCurrency) {
                        var r = document.querySelector(".currency-switcher-btn.selected");
                        r ? DoublyGlobalCurrency.convertAll(r.getAttribute("doubly-currency")) : (r = document.querySelector("[name=doubly-currencies]")) && DoublyGlobalCurrency.convertAll(r.value)
                    }
                }
            } catch (e) {
                mmErrorLog(e)
            }
        }
        ), mobileMenuMilliseconds)),
        setTimeout((function() {
            mmClicked = !1
        }
        ), mobileMenuMilliseconds + 50)
    }, applyOnClick = function() {
        disableOnClick || null == selectedMenu || "none" == selectedMenu || (mmClicked = !1,
        mmForEach(document, burgerIcon, (function(e) {
            e.removeEventListener("click", mmEvtApplyOnClick),
            e.addEventListener("click", mmEvtApplyOnClick)
        }
        )))
    }, initSchema = function() {
        if (0 == initializedSchema) {
            initializedSchema = !0,
            "string" == typeof mmSchemaDesignJSON && (mmSchemaDesignJSON = JSON.parse(mmSchemaDesignJSON));
            for (var e = 0; e < mmSchemaDesignJSON.length; e++) {
                var t = mmSchemaDesignJSON[e];
                if ("design" == t.action && null != t.setting)
                    if (-1 != t.setting.indexOf("main_menu_item_size_")) {
                        var n = t.setting.replace("main_menu_item_size_", "");
                        submenuSizes[n] = parseInt(t.value) + 25
                    } else if (-1 != t.setting.indexOf("main_menu_item_direction_")) {
                        n = t.setting.replace("main_menu_item_direction_", "");
                        submenuDirections[n] = t.value
                    } else if (-1 != t.setting.indexOf("main_menu_item_columns_")) {
                        n = t.setting.replace("main_menu_item_columns_", "");
                        submenuColumns[n] = t.value
                    }
            }
            if (recreateDesign(),
            action = "",
            window.self !== window.top) {
                var m = parent;
                void 0 === parent.postMessage && (m = top),
                m.postMessage(["updateToolbar", JSON.stringify(mmSchemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "*")
            }
        }
    }, iframeReady = function() {
        previewPanelLoaded = !0,
        document.getElementById("mega-menu-iframe").contentWindow.postMessage(["updateToolbar", JSON.stringify(mmSchemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "https://buddhaapps.com")
    }, reloadPreview = function() {
        location.reload()
    }, initCountdown = function(e) {
        var t = e.getAttribute("countdown_start")
          , n = e.getAttribute("countdown_end")
          , m = new Date;
        if (null == e.querySelector(".buddha-menu-item-countdown") && null != t && !isNaN(Date.parse(t)) && null != n && !isNaN(Date.parse(n))) {
            var o = (new Date(n).getTime() - m.getTime()) / 1e3
              , a = m.getTime() >= new Date(t).getTime();
            o < 0 && (o = 0);
            var i = !1;
            if ("undefined" == typeof mmSettingsPage || 0 != a && 0 != o || (i = !0,
            a = !0,
            o = 1),
            1 == a && o > 0) {
                var r = ' <i class="buddha-menu-item-countdown' + (i ? " inactive" : "") + '"> <div></div> </i>'
                  , u = e.querySelector("a>i.mm-angle-down");
                if (u || (u = e.querySelector("a>.mm-label")),
                u)
                    u.insertAdjacentHTML("beforebegin", r);
                else {
                    var l = e.querySelector("a");
                    l && l.insertAdjacentHTML("beforeend", r)
                }
                var s = e.querySelector(".buddha-menu-item-countdown");
                if (s) {
                    var c = "HourlyCounter";
                    s.classList.add("HourlyCounter"),
                    (o > 172800 || i) && (c = "DailyCounter",
                    s.classList.remove("HourlyCounter")),
                    "function" == typeof jQueryBuddha && "function" == typeof jQueryBuddha.fn.FlipClock && jQueryBuddha(s.firstElementChild).FlipClock(o, {
                        clockFace: c,
                        countdown: !0
                    })
                }
            }
        }
    }, generateMobileMenuColors = function(e, t) {
        var n = ""
          , m = ".vertical-mega-menu>" + (1 == t ? "li" : ".buddha-menu-item") + ">.mm-submenu.height-transition"
          , o = LightenDarkenColor(e, 20);
        if (getBrightness(e) < 220)
            for (var a = 1; a < 8; a++)
                n += m + "{background-color: " + e + " !important;} ",
                n += m + ">li{background-color: inherit !important;} ",
                n += m + ">li>a{background-color: inherit !important;} ",
                n += m + ">li>a>.toggle-menu-btn>.mm-cross{background-color: " + o + " !important;} ",
                m += ">li>.mm-submenu.height-transition",
                e = LightenDarkenColor(e, 20),
                o = LightenDarkenColor(o, 20);
        else
            n += m + "{background-color: " + e + " !important;} ",
            n += m + ">li{background-color: inherit !important;} ",
            n += m + ">li>a{background-color: inherit !important;} ",
            n += m + ">li>a>.toggle-menu-btn>.mm-cross{background-color: " + o + " !important;} ";
        return n
    }, shadeColor = function(e, t) {
        var n = parseInt(e.slice(1), 16)
          , m = t < 0 ? 0 : 255
          , o = t < 0 ? -1 * t : t
          , a = n >> 16
          , i = n >> 8 & 255
          , r = 255 & n;
        return "#" + (16777216 + 65536 * (Math.round((m - a) * o) + a) + 256 * (Math.round((m - i) * o) + i) + (Math.round((m - r) * o) + r)).toString(16).slice(1)
    }, customPropSettingsStyles = function(e, t) {
        var n = "";
        switch (e) {
        case "countdown_background_color":
        case "vertical_countdown_background_color":
            var m = ".horizontal-mega-menu";
            "vertical_countdown_background_color" == e && (m = ".vertical-mega-menu");
            var o = t;
            n += m + " .flip-clock-wrapper ul.play li.flip-clock-before .up .shadow, .flip-clock-wrapper ul.play li.flip-clock-active .up .shadow  {background: -moz-linear-gradient(top, rgba(0, 0, 0, 0.1) 0%, " + (t = shadeColor(t, -.5)) + " 100%) !important;background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, rgba(0, 0, 0, 0.1)), color-stop(100%, " + t + ")) !important;background: linear, top, rgba(0, 0, 0, 0.1) 0%, " + t + " 100% !important;background: -o-linear-gradient(top, rgba(0, 0, 0, 0.1) 0%, " + t + " 100%) !important;background: -ms-linear-gradient(top, rgba(0, 0, 0, 0.1) 0%, " + t + " 100%) !important;background: linear, to bottom, rgba(0, 0, 0, 0.1) 0%, " + t + " 100% !important;}",
            n += m + " .flip-clock-wrapper ul.play li.flip-clock-before .down .shadow, .flip-clock-wrapper ul.play li.flip-clock-active .down .shadow {background: -moz-linear-gradient(top, " + t + " 0%, rgba(0, 0, 0, 0.1) 100%) !important;background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, " + t + "), color-stop(100%, rgba(0, 0, 0, 0.1))) !important;background: linear, top, " + t + " 0%, rgba(0, 0, 0, 0.1) 100% !important;background: -o-linear-gradient(top, " + t + " 0%, rgba(0, 0, 0, 0.1) 100%) !important;background: -ms-linear-gradient(top, " + t + " 0%, rgba(0, 0, 0, 0.1) 100%) !important;background: linear, to bottom, " + t + " 0%, rgba(0, 0, 0, 0.1) 100% !important;}",
            n += m + " .buddha-menu-item-countdown .inn { text-shadow: 0 1px 2px " + shadeColor(t, -.3) + " !important; } .buddha-menu-item .flip-clock-wrapper ul li a div.down:after {background-color: " + o + " !important}";
            break;
        case "background_color":
            n += ".horizontal-mega-menu .mm-submenu.tabbed { background-color: " + LightenDarkenColor(t, -5) + " !important; }";
            break;
        case "background_hover_color":
            n += ".horizontal-mega-menu .buddha-menu-item .mm-submenu.tabbed > li.tab-opened { background-color: " + LightenDarkenColor(t, -5) + " !important; }";
            break;
        case "background_image_text_color":
            n += ".horizontal-mega-menu .buddha-menu-item ul.mm-submenu.simple.backgroundImage > li .mm-list-name > span {border-bottom: 1px solid " + t + " !important;}";
            break;
        case "vertical_text_color":
            n += ".vertical-mega-menu ul.mm-submenu.simple > li .mm-list-name  { border-bottom: 1px solid " + t + " !important; }";
            break;
        case "vertical_background_color":
            mmRemove("#buddhaInitialMobileMenuColors"),
            n += generateMobileMenuColors(t, !1);
            break;
        case "font_size":
            n += ".horizontal-mega-menu .buddha-menu-item .mm-description {font-size: " + (parseInt(t) - 1) + "px !important;}";
            break;
        case "vertical_font_size":
            n += ".vertical-mega-menu .buddha-menu-item .mm-description {font-size: " + (parseInt(t) - 1) + "px !important;}";
            break;
        case "addtocart_background_color":
            "#ffffff" == t && (t = "#000000"),
            n += ".horizontal-mega-menu .mm-add-to-cart>div {border-color: " + t + " !important;}";
            break;
        case "addtocart_enable":
            n += 1 == t || "true" == t ? ".horizontal-mega-menu .mm-add-to-cart {display: block !important;}" : ".horizontal-mega-menu .mm-add-to-cart {display: none !important;}";
            break;
        case "addtocart_background_hover_color":
            "#ffffff" == t && (t = "#000000"),
            n += ".horizontal-mega-menu .buddha-menu-item .mm-submenu .mm-add-to-cart>div:hover {border-color: " + t + " !important;}";
            break;
        case "vertical_addtocart_enable":
            n += 1 == t || "true" == t ? ".vertical-mega-menu .mm-add-to-cart {display: block !important;}" : ".vertical-mega-menu .mm-add-to-cart {display: none !important;}";
            break;
        case "vertical_addtocart_text_color":
            n += ".vertical-mega-menu .buddha-menu-item .mm-submenu .mm-add-to-cart>div:hover {color: " + LightenDarkenColor(t, -20) + " !important;}";
            break;
        case "vertical_addtocart_background_color":
            n += ".vertical-mega-menu .buddha-menu-item .mm-add-to-cart>div {border-color: " + t + " !important;}",
            n += ".vertical-mega-menu .buddha-menu-item .mm-submenu .mm-add-to-cart>div:hover {border-color: " + LightenDarkenColor(t, -20) + " !important;background-color: " + LightenDarkenColor(t, -20) + " !important;}";
            break;
        case "vertical_price_color":
            var a = getBrightness(t);
            n += ".vertical-mega-menu .buddha-menu-item ul.mm-submenu.simple>li .mega-menu-prices span.mega-menu-compare_at_price span {color: " + LightenDarkenColor(t, l = a > 190 ? -40 : 40) + ";}";
            break;
        case "contact_left_bg_color":
            n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info,.horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info a {background: " + t + " !important;}";
            break;
        case "contact_left_alt_color":
            for (var i = !1, r = mmSchemaDesignJSON.length - 1; r >= 0; r--) {
                var u = mmSchemaDesignJSON[r];
                if ("design" == u.action && "contact_left_bg_color" == u.setting) {
                    "#ffffff" != u.value && u.value != t || (i = !0);
                    break
                }
            }
            var l = (a = getBrightness(t)) > 190 ? -60 : 60;
            i ? (n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info>div>div>i{color: inherit !important;}",
            n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info .mm-socialmedia>a:hover {background: inherit !important;}",
            n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info .mm-img {visibility: hidden !important;}") : (n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info>div>div>i{color: " + t + " !important;}",
            n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info .mm-socialmedia>a:hover {background: " + t + " !important;}",
            n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info .mm-socialmedia>a:hover>i {color: " + LightenDarkenColor(t, parseInt(2 * l)) + " !important;}",
            n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info .mm-img>.mm-large {background: " + t + " !important;}",
            n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info .mm-img>.mm-small {background: " + LightenDarkenColor(t, l) + "f0 !important;}");
            break;
        case "contact_left_text_color":
            n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info,.horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info a{color: " + t + " !important;}";
            break;
        case "contact_right_text_color":
            n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu.mm-contact>.mm-form {color: " + t + " !important;}";
            break;
        case "contact_right_bg_color":
            n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu.mm-contact {background: " + t + " !important;}",
            n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu.mm-contact input, .horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu.mm-contact textarea { border-bottom: 1px solid " + LightenDarkenColor(t, -40) + " !important; }",
            n += ".horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu.mm-contact input:focus, .horizontal-mega-menu>.buddha-menu-item>ul.mm-submenu.mm-contact textarea:focus  {border-bottom: 1px solid " + LightenDarkenColor(t, -100) + " !important;}";
            break;
        case "vertical_contact_left_alt_color":
            a = getBrightness(t);
            n += ".vertical-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info>div>div>i{color: " + t + " !important;}",
            n += ".vertical-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info .mm-socialmedia>a:hover {background: " + t + " !important;}",
            n += ".vertical-mega-menu>.buddha-menu-item>ul.mm-submenu li.mm-contact-column.mm-info .mm-socialmedia>a:hover>i {color: " + LightenDarkenColor(t, l = a > 190 ? -120 : 120) + " !important;}";
            break;
        case "contact_right_btn_bg_color":
            n += ".horizontal-mega-menu ul.mm-submenu li.mm-contact-column button:hover{background: " + (t = LightenDarkenColor(t, -20)) + " !important;}";
            break;
        case "vertical_contact_right_btn_bg_color":
            n += ".vertical-mega-menu .buddha-menu-item ul.mm-submenu li.mm-contact-column button:hover{background: " + (t = LightenDarkenColor(t, -20)) + " !important;}"
        }
        return n
    }, applyMegaMenu = function(e) {
        try {
            if ("undefined" != typeof mutationExceptions && (mutationExceptions[mutationExceptions.length] = "ul"),
            "undefined" != typeof hideOriginalMenuInterval && clearInterval(hideOriginalMenuInterval),
            null != e) {
                var t = [];
                selectedMenu = e;
                for (var n = 0; n < mmSchemaDesignJSON.length; n++)
                    "menu-select" != mmSchemaDesignJSON[n].action && t.push(mmSchemaDesignJSON[n]);
                mmSchemaDesignJSON = t,
                changedMenu = !0
            } else
                for (n = 0; n < mmSchemaDesignJSON.length; n++)
                    "menu-select" == mmSchemaDesignJSON[n].action && (selectedMenu = mmSchemaDesignJSON[n].value);
            0 == mmApplyOnce && (mmForEach(document, ".vertical-mega-menu", (function(e) {
                e.classList.remove("vertical-mega-menu")
            }
            )),
            mmForEach(document, ".horizontal-mega-menu", (function(e) {
                e.classList.remove("horizontal-mega-menu")
            }
            )),
            mmForEach(document, ".buddha-disabled", (function(e) {
                e.classList.remove("buddha-disabled")
            }
            )),
            mmForEach(document, ".buddha-menu-item,#themeScript", (function(e) {
                e.parentNode.removeChild(e)
            }
            ))),
            mmMenuUls = [];
            var m = []
              , o = Object.keys(linkLists);
            for (n = 0; n < o.length; n++)
                if (selectedMenu == o[n]) {
                    m = linkLists[o[n]].items;
                    break
                }
            if (window.self !== window.top && console.log(m),
            null != selectedMenu && "none" != selectedMenu && (m.length > 0 || null != customMenuUls) || "undefined" != typeof mmSettingsPage) {
                mmForEach(document, customMenuUls || "ul,nav", (function(e) {
                    (tempMenuObject = {}).u = e,
                    "function" == typeof jQueryBuddha && (tempMenuObject.ul = jQueryBuddha(e)),
                    tempMenuObject.forceMenu = !1,
                    tempMenuObject.skipCheck = !1,
                    tempMenuObject.elementFits = 0;
                    var t = [];
                    if (1 == mmApplyOnce && (e.classList.contains("vertical-mega-menu") || e.classList.contains("horizontal-mega-menu")))
                        return !0;
                    if (("undefined" == typeof mmThemeFixesBefore || 0 != disableThemeScript || -1 != mmThemeFixesBefore.call(e)) && (tempMenuObject.skipCheck || mmForEachChild(e, "LI", (function(e) {
                        var t = null
                          , n = e.querySelector("a");
                        (n && (t = n.getAttribute("href")),
                        null == t || null != t && ("#" == t.substr(0, 1) || "" == t)) && ((o = e.querySelector(document.documentMode ? "* + a" : "a:nth-child(2)")) && (t = o.getAttribute("href"),
                        n = o));
                        null != t && (null == t || "#" != t.substr(0, 1) && "" != t) || (o = e.querySelector("a>a")) && (t = o.getAttribute("href"),
                        n = o);
                        if (null == t || null != t && ("#" == t.substr(0, 1) || "" == t))
                            for (var o = e.querySelectorAll("a[href]"), a = 0; a < o.length; a++) {
                                var i = o[a].getAttribute("href");
                                if (null != m[tempMenuObject.elementFits] && i == m[tempMenuObject.elementFits]) {
                                    t = i,
                                    n = o[a];
                                    break
                                }
                            }
                        null != m[tempMenuObject.elementFits] && t == m[tempMenuObject.elementFits] ? (null == tempMenuObject.liClasses && (tempMenuObject.liClasses = ""),
                        tempMenuObject.liClasses = concatClasses(e.getAttribute("class"), tempMenuObject.liClasses),
                        null == tempMenuObject.aClasses && (tempMenuObject.aClasses = ""),
                        n && (tempMenuObject.aClasses = concatClasses(n.getAttribute("class"), tempMenuObject.aClasses)),
                        null == tempMenuObject.liItems && (tempMenuObject.liItems = []),
                        -1 == Array.from(tempMenuObject.liItems).indexOf(e) && (tempMenuObject.liItems[tempMenuObject.liItems.length] = e),
                        e.classList.add("buddha-transparent"),
                        tempMenuObject.elementFits++) : tempMenuObject.elementFits > 0 && tempMenuObject.elementFits != m.length && (tempMenuObject.elementFits = 0,
                        tempMenuObject.liItems = [],
                        mmForEach(document, ".buddha-transparent", (function(e) {
                            e.classList.remove("buddha-transparent")
                        }
                        )),
                        t == m[0] && (tempMenuObject.elementFits = 1,
                        tempMenuObject.liItems[tempMenuObject.liItems.length] = e,
                        e.classList.add("buddha-transparent")))
                    }
                    )),
                    "undefined" == typeof mmCustomerFixesBefore || mmFixesUseJquery && (!mmFixesUseJquery || "function" != typeof jQueryBuddha) || -1 != mmCustomerFixesBefore.call(e)))
                        if (tempMenuObject.elementFits > 0 && tempMenuObject.elementFits == m.length && null == tempMenuObject.u.closest(".buddha-disabled") || tempMenuObject.forceMenu) {
                            for (var n = getSpecificClasses(tempMenuObject.liClasses), o = getSpecificClasses(tempMenuObject.aClasses), a = 0; a < tempMenuObject.liItems.length; a++) {
                                var i;
                                void 0 !== tempMenuObject.liItems[a] && (i = void 0 !== tempMenuObject.liItems[a].get ? tempMenuObject.liItems[a].get(0) : tempMenuObject.liItems[a]) && void 0 !== i && (i.classList.remove("buddha-transparent"),
                                i.classList.add("buddha-disabled"))
                            }
                            if (mmWireframe) {
                                void 0 !== mmWireframe.html && (mmWireframe = mmWireframe.html),
                                e.insertAdjacentHTML("afterbegin", mmWireframe);
                                var r = mmForEach(e, ".buddha-menu-item>.mm-submenu", (function(e) {
                                    e.setAttribute("style", "display: none !important;")
                                }
                                ), !0);
                                t = mmForEach(e, ".buddha-menu-item", (function(e) {
                                    var t = e.getAttribute("itemId");
                                    t && (void 0 !== submenuSizes[t] && e.setAttribute("submenu-size", submenuSizes[t]),
                                    void 0 !== submenuDirections[t] && e.setAttribute("submenu-direction", submenuDirections[t]),
                                    void 0 !== submenuColumns[t] && e.setAttribute("submenu-columns", submenuColumns[t])),
                                    mmAddClasses(e, n.common),
                                    mmForEachChild(e, "A", (function(e) {
                                        mmAddClasses(e, o.common)
                                    }
                                    ))
                                }
                                ), !0),
                                mmForEach(e, ".buddha-menu-item[countdown_start]", (function(e) {
                                    initCountdown(e)
                                }
                                )),
                                mmForEach(e, ".buddha-menu-item>a>.mm-label", (function(e) {
                                    e.classList.add("mm-hidden")
                                }
                                )),
                                mmForEach(e, ".mm-sold-out", (function(e) {
                                    var t = e.parentNode.querySelector(".mm-add-to-cart");
                                    t && t.style.setProperty("display", "none", "important")
                                }
                                )),
                                mmForEach(e, ".get-collection-image", (function(e) {
                                    var t = e.getAttribute("data-id");
                                    if (null != collectionImages[t] && -1 == collectionImages[t][0].indexOf("no-image") && null == e.getAttribute("customimage")) {
                                        var n = e.closest("li[submenu-columns]")
                                          , m = e.closest("li[image-type]");
                                        n && (n = n.getAttribute("submenu-columns")),
                                        m && (m = m.getAttribute("image-type")),
                                        n = n || 1,
                                        null != m && -1 != m.indexOf("crop") && n++;
                                        var o = [320, 640, 960, 1280, -1, -1][n - 1];
                                        -1 != o ? (collectionImages[t][0] = collectionImages[t][0].replace("_240x.", "_" + o + "x."),
                                        collectionImages[t][0] = collectionImages[t][0].replace("&width=240", "&width=" + o)) : (collectionImages[t][0] = collectionImages[t][0].replace("_240x.", "."),
                                        collectionImages[t][0] = collectionImages[t][0].replace("&width=240", "")),
                                        e.setAttribute("data-src", collectionImages[t][0]),
                                        e.setAttribute("aspect-ratio", collectionImages[t][1])
                                    }
                                }
                                )),
                                mmForEach(e, ".get-product-image", (function(e) {
                                    var t = e.getAttribute("data-id");
                                    if (null != productImageAndPrice[t] && -1 == productImageAndPrice[t][0].indexOf("no-image") && null == e.getAttribute("customimage")) {
                                        var n = e.closest("li[submenu-columns]")
                                          , m = e.closest("li[image-type]");
                                        n && (n = n.getAttribute("submenu-columns")),
                                        m && (m = m.getAttribute("image-type")),
                                        n = n || 1,
                                        null != m && -1 != m.indexOf("crop") && n++;
                                        var o = [320, 640, 960, 1280, -1, -1][n - 1];
                                        -1 != o ? (productImageAndPrice[t][0] = productImageAndPrice[t][0].replace("_240x.", "_" + o + "x."),
                                        productImageAndPrice[t][0] = productImageAndPrice[t][0].replace("&width=240", "&width=" + o)) : (productImageAndPrice[t][0] = productImageAndPrice[t][0].replace("_240x.", "."),
                                        productImageAndPrice[t][0] = productImageAndPrice[t][0].replace("&width=240", "")),
                                        e.setAttribute("data-src", productImageAndPrice[t][0]),
                                        e.setAttribute("aspect-ratio", productImageAndPrice[t][1])
                                    }
                                    if (null != productImageAndPrice[t]) {
                                        var a = e.closest("li");
                                        if (a) {
                                            var i = a.querySelector(".mm-add-to-cart>div");
                                            i && (i.setAttribute("varid", productImageAndPrice[t][3]),
                                            i.setAttribute("sellingplan", productImageAndPrice[t][4]))
                                        }
                                    }
                                }
                                )),
                                mmForEach(e, ".get-article-image", (function(e) {
                                    var t = e.getAttribute("data-id");
                                    if (null != articleImages[t] && -1 == articleImages[t][0].indexOf("no-image") && null == e.getAttribute("customimage")) {
                                        var n = e.closest("li[submenu-columns]")
                                          , m = e.closest("li[image-type]");
                                        n && (n = n.getAttribute("submenu-columns")),
                                        m && (m = m.getAttribute("image-type")),
                                        n = n || 1,
                                        null != m && -1 != m.indexOf("crop") && n++;
                                        var o = [320, 640, 960, 1280, -1, -1][n - 1];
                                        articleImages[t][0] = -1 != o ? articleImages[t][0].replace("&width=240", "&width=" + o) : articleImages[t][0].replace("&width=240", ""),
                                        e.setAttribute("data-src", articleImages[t][0]),
                                        e.setAttribute("aspect-ratio", articleImages[t][1])
                                    }
                                }
                                )),
                                mmForEach(e, "img[data-src]", (function(e) {
                                    var t = e.getAttribute("placeholder");
                                    t && e.setAttribute("data-src", mmExtensionAssetUrl + t),
                                    e.classList.add("mmLazyload")
                                }
                                ));
                                var u = document.querySelector("#mmContactFormHTML>li");
                                u && (mmForEach(e, "#contactFormWidget", (function(e) {
                                    var t = e.parentElement;
                                    t.appendChild(u.cloneNode(!0)),
                                    t.removeChild(e)
                                }
                                )),
                                u.parentElement.addEventListener("click", (function(e) {
                                    return e.stopImmediatePropagation(),
                                    !1
                                }
                                )));
                                var l = function() {
                                    var e = document.querySelector("#mmContactFormHTML input");
                                    e && e.click()
                                };
                                if (mmForEach(e, ".mm-contact-column input,.mm-contact-column textarea", (function(e) {
                                    e.removeEventListener("focus", l),
                                    e.removeEventListener("click", l),
                                    e.addEventListener("focus", l),
                                    e.addEventListener("click", l)
                                }
                                )),
                                mmForEach(e, ".mm-contact", (function(e) {
                                    var t = e.closest(".buddha-menu-item");
                                    t && null == t.getAttribute("submenu-size") && (e.matches(".mm-no-business-info") ? t.setAttribute("submenu-size", 700) : t.setAttribute("submenu-size", 850))
                                }
                                )),
                                document.documentMode && (mmForEach(e, ".mm-product-list img", (function(e) {
                                    var t = "url(" + e.getAttribute("data-src") + ")";
                                    e.parentNode.insertAdjacentHTML("beforeend", '<div style="height:50px;width:50px;background-size:cover;background-repeat:no-repeat;background-position:50% 50%;background-image:' + t + '"></div>'),
                                    e.style.display = "none"
                                }
                                )),
                                mmAddStyle(".buddha-menu-item .mm-image a {width:100% !important; height: 100% !important;}", "mmIE11Fix")),
                                r)
                                    for (a = 0; a < r.length; a++)
                                        r[a].removeAttribute("style")
                            } else
                                console.log("Megamenu ERROR - wireframe missing.");
                            if (n.first || o.first || n.last || o.last) {
                                var s = e.querySelectorAll(".buddha-menu-item");
                                if (s.length)
                                    mmAddClasses(s[0], n.first),
                                    mmAddClasses(s[s.length - 1], n.last),
                                    (c = s[0].querySelector("a")) && mmAddClasses(c, o.first),
                                    (c = s[s.length - 1].querySelector("a")) && mmAddClasses(c, o.last)
                            }
                            if (n.active || o.active)
                                for (a = 0; a < t.length; a++) {
                                    var c;
                                    (c = t[a].querySelector("a")) && c.getAttribute("data-href") == window.location.pathname && (mmAddClasses(c, o.active),
                                    mmAddClasses(t[a], n.active))
                                }
                            if ("undefined" != typeof mmThemeFixesAfter && 0 == disableThemeScript && -1 == mmThemeFixesAfter.call(e))
                                return;
                            if ("undefined" != typeof mmCustomerFixesAfter && (!mmFixesUseJquery || mmFixesUseJquery && "function" == typeof jQueryBuddha) && -1 == mmCustomerFixesAfter.call(e))
                                return;
                            void 0 !== burgerIcon && "*" != burgerIcon || mmForEach(document, 'input[type="search"],input[type="text"]', (function(e) {
                                e.classList.add("stop-mega-menu-reinit")
                            }
                            ));
                            var d = document.querySelector(".dl-menu");
                            d && setTimeout((function() {
                                document.addEventListener("toggleSubmenu", (function() {
                                    setTimeout((function() {
                                        d.classList.add("dl-menuopen")
                                    }
                                    ), 1)
                                }
                                ))
                            }
                            ), 100),
                            "undefined" != typeof timber && void 0 !== timber.alignMenu && (timber.alignMenu = function() {}
                            );
                            var g = !1;
                            if (-1 == mmMenuUls.indexOf(e)) {
                                for (a = 0; a < mmMenuUls.length; a++)
                                    mmMenuUls[a].contains(e) && (g = !0);
                                g || (mmMenuUls[mmMenuUls.length] = e)
                            }
                            tempMenuObject = {}
                        } else
                            mmForEach(document, ".buddha-transparent", (function(e) {
                                e.classList.remove("buddha-transparent")
                            }
                            ))
                }
                ));
                for (n = 0; n < mmMenuUls.length; n++)
                    livIconsOptionsCache[n] = {
                        opt: "",
                        optMain: "",
                        optBg: ""
                    },
                    reinitMenus(mmMenuUls[n]);
                addTouch()
            }
            if (mmForEach(document, ".buddha-disabled-menu", (function(e) {
                e.classList.remove("buddha-disabled-menu")
            }
            )),
            mmRemove("#mmHideOriginalMenuStyle"),
            window.self !== window.top) {
                var a = parent;
                void 0 === parent.postMessage && (a = top),
                a.postMessage(["updateToolbar", JSON.stringify(mmSchemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "*")
            } else
                previewPanelLoaded && document.getElementById("mega-menu-iframe").contentWindow.postMessage(["updateToolbar", JSON.stringify(mmSchemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "https://buddhaapps.com");
            setTimeout((function() {
                "undefined" != typeof mutationExceptions && mutationExceptions.pop()
            }
            ), 100)
        } catch (e) {
            mmErrorLog(e)
        }
    }, addUpdateLivIcons = function(e) {
        var t = function() {
            if (e && "function" == typeof jQueryBuddha) {
                var t = e.querySelectorAll(".mm-icon.dynamic");
                if (t) {
                    var n = e.querySelector(".buddha-menu-item>a>.mm-title");
                    if (n) {
                        var m, o, a, i = window.getComputedStyle(n).getPropertyValue("color");
                        e.matches(".horizontal-mega-menu") ? (m = {
                            strokeColor: livIconsOptions.horizontalColor,
                            colorsOnHover: "custom",
                            strokeColorAction: livIconsOptions.horizontalHover,
                            eventOn: "parent"
                        },
                        o = {
                            strokeColor: i,
                            eventOn: "parent"
                        },
                        a = {
                            strokeColor: livIconsOptions.horizontalBackgroundImageColor,
                            colorsOnHover: "custom",
                            strokeColorAction: livIconsOptions.horizontalHover,
                            eventOn: "parent"
                        }) : (o = {
                            strokeColor: i,
                            eventOn: "parent"
                        },
                        a = m = {
                            strokeColor: livIconsOptions.verticalColor,
                            colorsOnHover: "custom",
                            strokeColorAction: livIconsOptions.verticalHover,
                            eventOn: "parent"
                        });
                        var r = !1
                          , u = JSON.stringify(m)
                          , l = JSON.stringify(o)
                          , s = JSON.stringify(a)
                          , c = mmMenuUls.indexOf(e);
                        void 0 === livIconsOptionsCache[c] && (livIconsOptionsCache[c] = {
                            opt: "",
                            optMain: "",
                            optBg: ""
                        }),
                        u != livIconsOptionsCache[c].opt && (livIconsOptionsCache[c].opt = u,
                        r = !0),
                        l != livIconsOptionsCache[c].optMain && (livIconsOptionsCache[c].optMain = l,
                        r = !0),
                        s != livIconsOptionsCache[c].optBg && (livIconsOptionsCache[c].optBg = s,
                        r = !0);
                        for (var d = 0; d < t.length; d++) {
                            var g, p = m;
                            if (t[d].matches(".buddha-menu-item>a>.mm-icon") ? p = o : t[d].closest(".backgroundImage") && (p = a),
                            t[d].matches(".livicon-evo-holder")) {
                                if (r)
                                    if (g = t[d].parentElement) {
                                        var h = g.removeChild(t[d]);
                                        g.parentElement && g.parentElement.matches(".buddha-menu-item") && h.classList.add("mm-livicons-quickload"),
                                        jQueryBuddha(h).addLiviconEvo(p),
                                        g.insertBefore(h, g.firstElementChild)
                                    }
                            } else if (g = t[d].parentElement) {
                                h = g.removeChild(t[d]);
                                g.parentElement && g.parentElement.matches(".buddha-menu-item") && h.classList.add("mm-livicons-quickload"),
                                jQueryBuddha(h).addLiviconEvo(p),
                                g.insertBefore(h, g.firstElementChild)
                            }
                        }
                    }
                }
            }
        };
        "function" == typeof jQueryBuddha && (void 0 !== jQueryBuddha.fn.addLiviconEvo ? t() : "undefined" != typeof loadLivIconsBuddha ? (loadLivIconsBuddha(jQueryBuddha),
        t()) : setTimeout((function() {
            "undefined" != typeof loadLivIconsBuddha ? (loadLivIconsBuddha(jQueryBuddha),
            t()) : setTimeout((function() {
                "undefined" != typeof loadLivIconsBuddha ? (loadLivIconsBuddha(jQueryBuddha),
                t()) : console.log("liv err")
            }
            ), 3e3)
        }
        ), 500))
    }, mmEvtEnterMmi = function(e) {
        var t = e.target;
        setSubmenuBoundries(t),
        setContactSubmenuBoundries(t);
        var n = t.querySelector(".tab-opened");
        n && setTabbedSubmenuBoundries(n)
    }, mmOpenMenuTab = function(e) {
        mmForEach(e.parentNode, ".tab-opened", (function(e) {
            e.classList.remove("tab-opened")
        }
        )),
        e.classList.add("tab-opened"),
        setTabbedSubmenuBoundries(e)
    }, mmEnterTabbedLiTimeout, mmEvtEnterTabbedLi = function(e) {
        mmClickToggle < 2 && (0 == mmMenuOpenDelay ? mmOpenMenuTab(e.target) : (clearTimeout(mmEnterTabbedLiTimeout),
        mmEnterTabbedLiTimeout = setTimeout((function() {
            mmOpenMenuTab(e.target)
        }
        ), mmMenuOpenDelay)))
    }, reinitMenus = function(e, t) {
        "string" == typeof e && (e = document.querySelector(e));
        var n = mmGetChildren(e, ".buddha-menu-item")
          , m = 0 != mmVerticalMenus && null != document.querySelector(mmVerticalMenus) && e.matches(mmVerticalMenus)
          , o = window.innerWidth;
        if (t = void 0 !== t ? t : "auto",
        0 != mmDisableVisibleCheck || 0 != mmVerticalMenus && !m || !(o <= 800) || mmIsVisible(e) || "auto" != t) {
            e.classList.remove("vertical-mega-menu"),
            e.classList.remove("horizontal-mega-menu");
            var a = mmForEach(e, ".buddha-menu-item>.mm-submenu", (function(e) {
                e.style.setProperty("display", "none", "important")
            }
            ), !0)
              , i = 1;
            if (null != document.querySelector(mmHorizontalMenus) && e.matches(mmHorizontalMenus))
                t = "horizontal";
            else if (m)
                t = "vertical";
            else
                for (var r, u = 0; u < n.length; u++) {
                    var l = n[u].offsetTop;
                    void 0 === r && (r = l),
                    (l > r + 5 || l < r - 5) && i++,
                    r = l
                }
            if ((i != n.length || 1 == i && o > verticalMenuMaxWidth) && 0 == forceMobile && "vertical" != t || "horizontal" == t) {
                if (e.classList.add("horizontal-mega-menu"),
                mmForEach(e, ".submenu-opened", (function(e) {
                    e.classList.remove("submenu-opened")
                }
                )),
                mmForEach(e, ".buddha-menu-item > a > .mm-label", (function(e) {
                    e.classList.remove("mm-hidden")
                }
                )),
                mmClickToggle) {
                    e.classList.add("mm-click-toggle"),
                    e.classList.add("mm-priority");
                    var s = ".buddha-menu-item,.mm-submenu.tree li";
                    2 == mmClickToggle && (s += ",.mm-submenu.tabbed>li"),
                    mmForEach(e, s, (function(e) {
                        if (null != e.querySelector(".mm-submenu")) {
                            for (var t = [e, e.querySelector("a")], n = 0; n < t.length; n++)
                                t[n].removeAttribute("href"),
                                t[n].removeAttribute("data-href"),
                                t[n].removeAttribute("onclick");
                            e.removeEventListener("click", mmAddHover),
                            e.addEventListener("click", mmAddHover)
                        }
                    }
                    ))
                }
                mmForEach(e, ".buddha-menu-item[countdown_start] > a > .mm-label", (function(e) {
                    null == e.parentNode.parentNode.querySelector(".mm-submenu") && e.style.setProperty("left", "0px", "important")
                }
                )),
                mmSetSmBoundriesOnReinit && setTimeout((function() {
                    for (var e = 0; e < n.length; e++)
                        setSubmenuBoundries(n[e]),
                        setContactSubmenuBoundries(n[e])
                }
                ), 1),
                mmForEach(e, "ul.mm-submenu.tabbed>li", (function(e) {
                    null == e.parentNode.querySelector(".tab-opened") ? (e.classList.add("tab-opened"),
                    mmSetSmBoundriesOnReinit && setTabbedSubmenuBoundries(e)) : e.classList.contains("tab-opened") && mmSetSmBoundriesOnReinit && setTabbedSubmenuBoundries(e)
                }
                )),
                mmForEach(e, "ul.mm-submenu.tabbed>li", (function(e) {
                    e.removeEventListener("mouseenter", mmEvtEnterTabbedLi),
                    e.addEventListener("mouseenter", mmEvtEnterTabbedLi)
                }
                )),
                mmForEach(e, "ul.mm-submenu.tabbed>li:first-child", (function(e) {
                    null == e.parentNode.querySelector(".tab-opened") && (e.classList.add("tab-opened"),
                    setTabbedSubmenuBoundries(e))
                }
                )),
                mmForEach(e, ".contact-form", (function(e) {
                    e.setAttribute("action", "/contact#contact_form1"),
                    e.id = "contact_form1"
                }
                ));
                for (u = 0; u < n.length; u++)
                    n[u].removeEventListener("mouseenter", mmEvtEnterMmi),
                    n[u].addEventListener("mouseenter", mmEvtEnterMmi),
                    panelOpened && (n[u].removeEventListener("mouseenter", mmEvtMouseEnterPreview),
                    n[u].addEventListener("mouseenter", mmEvtMouseEnterPreview))
            } else {
                e.classList.add("vertical-mega-menu"),
                mmClickToggle && (e.classList.remove("mm-click-toggle"),
                e.classList.remove("mm-priority"));
                var c = mmMenuUls.indexOf(e);
                e.setAttribute("menuIdx", c),
                mmForEach(e, ".mega-hover", (function(e) {
                    e.classList.remove("mega-hover")
                }
                ));
                for (u = 0; u < n.length; u++)
                    n[u].classList.remove("disabled"),
                    n[u].removeEventListener("mouseenter", mmEvtEnterMmi);
                mmForEach(e, ".toggle-menu-btn", (function(e) {
                    e.classList.add("fa-visible")
                }
                )),
                mmForEach(e, ".buddha-menu-item > a .mm-label", (function(e) {
                    e.classList.remove("mm-hidden")
                }
                )),
                mmForEach(e, ".submenu-opened", (function(e) {
                    e.classList.remove("submenu-opened"),
                    e.classList.remove("height-transition"),
                    e.removeAttribute("style")
                }
                )),
                mmForEach(e, ".toggle-menu-btn>.mm-cross", (function(e) {
                    e.classList.remove("mm-cross")
                }
                )),
                mmForEach(e, ".mm-submenu", (function(e) {
                    e.style.removeProperty("max-height"),
                    e.style.removeProperty("min-width")
                }
                )),
                mmForEach(e, ".mm-hovering", (function(e) {
                    e.classList.remove("mm-hovering")
                }
                ));
                var d = 0
                  , g = 0
                  , p = 0
                  , h = 0;
                if (n.length) {
                    var b = window.getComputedStyle(n[0])
                      , f = window.getComputedStyle(n[0].querySelector("a"));
                    d = b.getPropertyValue("padding-left"),
                    g = f.getPropertyValue("padding-left"),
                    p = f.getPropertyValue("padding-top"),
                    h = f.getPropertyValue("padding-bottom")
                }
                var v = parseInt(d) + parseInt(g);
                v <= 15 && (v = 15);
                var y = (parseInt(p) - parseInt(h)) / 2;
                y = y < 0 ? "top: calc(50% - " + -1 * y + "px) !important;" : "top: calc(50% + " + y + "px) !important;";
                var S = ""
                  , w = v + mmMobileMenuTreeOffsetLeft
                  , M = ".vertical-mega-menu>.buddha-menu-item>.mm-submenu.tree";
                for (u = 1; u < 8; u++)
                    S += M + ">li>a{margin-left: " + w + "px !important;} ",
                    S += M + ">li{padding-bottom: 5px !important; padding-top: 5px !important; box-sizing: border-box !important;} ",
                    w += 10,
                    M += ">li>.mm-submenu.tree";
                var _ = '.vertical-mega-menu[menuIdx="' + c + '"]>li.buddha-menu-item'
                  , E = "";
                E += _ + " ul.mm-submenu.tree>li>a>.toggle-menu-btn{right:" + v + "px !important;}",
                E += _ + " ul.mm-submenu.tree>li>a { padding-right: " + (v + 28) + "px !important; }",
                E += _ + " ul.mm-submenu.tree.mm-last-level>li>a{ padding-right: " + v + "px !important; }",
                E += _ + " ul.mm-submenu.simple>li.mm-left-item{padding-left:" + v + "px !important;}",
                E += _ + " ul.mm-submenu.simple>li.mm-right-item{padding-right:" + v + "px !important;}",
                E += _ + ">ul.mm-submenu.tabbed>li{padding-left:" + v + "px !important;padding-right:" + v + "px !important;}",
                E += _ + ">ul.mm-submenu.tabbed>li>ul.mm-submenu>li.mm-left-item {padding-left: 0px !important;}",
                E += _ + ">ul.mm-submenu.tabbed>li>ul.mm-submenu>li.mm-right-item {padding-right: 0px !important;}",
                E += _ + " ul.mm-submenu.mm-contact>li{padding-left:" + v + "px !important;padding-right:" + v + "px !important;}",
                E += _ + ">ul.mm-submenu.tabbed>li>ul.mm-submenu.simple { padding-left:" + v + "px !important; padding-right:" + v + "px !important; margin-left:-" + v + "px !important; margin-right:-" + v + "px !important; }",
                E += _ + " > a > .toggle-menu-btn { right:" + v + "px !important;" + y + "}",
                mmAddStyle(E += S, "verticalMenuSpacing" + c),
                mmForEach(e, ".tab-opened", (function(e) {
                    e.classList.remove("tab-opened")
                }
                )),
                forceMobile = !1
            }
            mmLivIcons && addUpdateLivIcons(e);
            var O = e.querySelector(".flip-clock-label");
            if (O)
                try {
                    var k = 7 / parseInt(getComputedStyle(O).fontSize) * 1.1;
                    k < 1 && mmAddStyle(".buddha-menu-item .flip-clock-label {transform: scale(" + k + ") translateX(-7px);}", "mmFlipClockFontStyle")
                } catch (e) {}
            if (panelOpened || mmForEach(document, ".mega-hover", (function(e) {
                e.classList.remove("mega-hover")
            }
            )),
            a)
                for (u = 0; u < a.length; u++)
                    a[u].style.removeProperty("display")
        }
    }, renderMobileMenuForce = function(e) {
        var t = document.querySelector(e);
        reinitMenus(t, "vertical")
    }, concatClasses = function(e, t) {
        var n = [];
        if (t && "" != t && (n = t.split(" ")),
        e && "" != e) {
            e = e.split(" ");
            for (var m = 0; m < e.length; m++)
                -1 == n.indexOf(e[m]) && (n[n.length] = e[m])
        }
        return n.join(" ")
    }, getSpecificClasses = function(e) {
        var t = [];
        if (null != e) {
            e = e.split(" ");
            for (var n = "", m = 0; m < e.length; m++) {
                var o = e[m];
                -1 != o.indexOf("active") || -1 != o.indexOf("selected") || -1 != o.indexOf("current") ? t.active = o : -1 != o.indexOf("focus") ? t.focus = o : -1 != o.indexOf("first") ? t.first = o : -1 != o.indexOf("last") ? t.last = o : -1 == o.indexOf("buddha") && -1 == o.indexOf("dropdown") && -1 == o.indexOf("mm-subopen") && -1 == o.indexOf("hidden") && -1 == o.indexOf("hide") && (n += " " + o)
            }
            t.common = n.trim()
        }
        return t
    }, undoAction = function() {
        if (currentUndo = undo[undo.length - 1],
        "design" == currentUndo.action && (redo.unshift(currentUndo),
        mmSchemaDesignJSON.splice(-1, 1),
        undo.splice(-1, 1),
        recreateDesign()),
        null == document.querySelector(".buddha-menu-item") && mmRemove("#themeScript"),
        window.self !== window.top) {
            var e = parent;
            void 0 === parent.postMessage && (e = top),
            e.postMessage(["updateToolbar", JSON.stringify(mmSchemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "*")
        } else
            previewPanelLoaded && document.getElementById("mega-menu-iframe").contentWindow.postMessage(["updateToolbar", JSON.stringify(mmSchemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "https://buddhaapps.com")
    }, redoAction = function() {
        if (tempMenuObject = {},
        mmForEach(document, ".buddha-transparent", (function(e) {
            e.classList.remove("buddha-transparent")
        }
        )),
        "design" == (action = redo[0].action) && (mmSchemaDesignJSON.push(redo[0]),
        undo.push(redo[0]),
        recreateDesign()),
        redo.splice(0, 1),
        null == document.querySelector(".buddha-menu-item") && mmRemove("#themeScript"),
        window.self !== window.top) {
            var e = parent;
            void 0 === parent.postMessage && (e = top),
            e.postMessage(["updateToolbar", JSON.stringify(mmSchemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "*")
        } else
            previewPanelLoaded && document.getElementById("mega-menu-iframe").contentWindow.postMessage(["updateToolbar", JSON.stringify(mmSchemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "https://buddhaapps.com")
    }, clearAction = function() {
        for (var e = 0; e < undo.length; e++)
            undoAction();
        if (redo = [],
        null == document.querySelector(".buddha-menu-item") && mmRemove("#themeScript"),
        window.self !== window.top) {
            var t = parent;
            void 0 === parent.postMessage && (t = top),
            t.postMessage(["updateToolbar", JSON.stringify(mmSchemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "*")
        } else
            previewPanelLoaded && document.getElementById("mega-menu-iframe").contentWindow.postMessage(["updateToolbar", JSON.stringify(mmSchemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "https://buddhaapps.com")
    }, propSettings = {
        background_color: {
            element: ".horizontal-mega-menu ul.mm-submenu, .horizontal-mega-menu>li>ul.mm-submenu.tabbed>li>ul.mm-submenu li,.horizontal-mega-menu li.buddha-menu-item:hover ul.mm-submenu.simple li:hover, .horizontal-mega-menu li.buddha-menu-item.mega-hover ul.mm-submenu.simple li:hover",
            attribute: "background"
        },
        background_hover_color: {
            element: ".horizontal-mega-menu ul.mm-submenu.tree li:hover, .horizontal-mega-menu ul.mm-submenu.tree li.mega-hover,.horizontal-mega-menu ul.mm-submenu.tabbed>li.tab-opened",
            attribute: "background"
        },
        background_image_text_color: {
            element: ".horizontal-mega-menu ul.mm-submenu.backgroundImage a, .horizontal-mega-menu ul.mm-submenu.backgroundImage li.mm-contact-column span,.horizontal-mega-menu ul.mm-submenu.backgroundImage .mm-contact-content, .horizontal-mega-menu ul.mm-submenu.backgroundImage li",
            attribute: "color"
        },
        text_color: {
            element: '.horizontal-mega-menu ul.mm-submenu,.horizontal-mega-menu ul.mm-submenu li,.horizontal-mega-menu ul.mm-submenu li.mm-contact-column span,.horizontal-mega-menu ul.mm-submenu li a,.horizontal-mega-menu ul.mm-submenu li a span,.horizontal-mega-menu ul.mm-submenu li.fa, .horizontal-mega-menu ul.mm-submenu.tree li:hover>a[data-href="no-link"], .horizontal-mega-menu ul.mm-submenu.tree li.mega-hover>a[data-href="no-link"], .horizontal-mega-menu ul.mm-submenu.tabbed>li.tab-opened>a[data-href="no-link"], .horizontal-mega-menu ul.mm-submenu li a[data-href="no-link"]:hover',
            attribute: "color"
        },
        link_hover_color: {
            element: ".horizontal-mega-menu ul.mm-submenu.tree li:hover>a, .horizontal-mega-menu ul.mm-submenu.tree li.mega-hover>a, .horizontal-mega-menu ul.mm-submenu.tabbed>li.tab-opened>a,.horizontal-mega-menu ul.mm-submenu.tabbed>li.tab-opened>a>.mm-title, .horizontal-mega-menu ul.mm-submenu li a:hover,.horizontal-mega-menu ul.mm-submenu li:hover>a, .horizontal-mega-menu ul.mm-submenu li a:hover i, .horizontal-mega-menu ul.mm-submenu li:hover>a>i, .horizontal-mega-menu ul.mm-submenu li a:hover>span, .horizontal-mega-menu ul.mm-submenu li:hover>a>span, .horizontal-mega-menu ul.mm-submenu.tree li.fa:hover:before, .horizontal-mega-menu ul.mm-submenu.tree li.mega-hover.fa:before, .horizontal-mega-menu ul.mm-submenu.tabbed>li.tab-opened.fa:before, .horizontal-mega-menu ul.mm-submenu>li>.mega-menu-item-container>.mm-list-name>span[onclick]:hover",
            attribute: "color"
        },
        font_size: {
            element: ".horizontal-mega-menu ul.mm-submenu,.horizontal-mega-menu ul.mm-submenu a,.horizontal-mega-menu ul.mm-submenu a>span,.horizontal-mega-menu ul.mm-submenu .money",
            attribute: "font-size"
        },
        price_color: {
            element: ".horizontal-mega-menu ul.mm-submenu.simple > li .mega-menu-prices span.mega-menu-price span",
            attribute: "color"
        },
        vertical_text_color: {
            element: ".vertical-mega-menu ul.mm-submenu,.vertical-mega-menu ul.mm-submenu li.mm-contact-column span,.vertical-mega-menu ul.mm-submenu li a, .vertical-mega-menu ul.mm-submenu span, .vertical-mega-menu ul.mm-submenu>li>a>.toggle-menu-btn>.fa",
            attribute: "color"
        },
        vertical_link_hover_color: {
            element: ".vertical-mega-menu ul.mm-submenu>li:hover>a[onclick]:not([data-href='no-link']), .vertical-mega-menu ul.mm-submenu>li:hover>a[onclick]:not([data-href='no-link'])>*, .vertical-mega-menu ul.mm-submenu>li.mm-hovering>a[onclick]:not([data-href='no-link']),.vertical-mega-menu ul.mm-submenu>li.mm-hovering>a[onclick]:not([data-href='no-link'])>*, .vertical-mega-menu ul.mm-submenu.tabbed>li.tab-opened>a[onclick]:not([data-href='no-link']), .vertical-mega-menu ul.mm-submenu.tabbed>li.tab-opened>a[onclick]:not([data-href='no-link'])>*, .vertical-mega-menu ul.mm-submenu li a[onclick]:not([data-href='no-link']):hover, .vertical-mega-menu ul.mm-submenu.tree li:hover>a[onclick]:not([data-href='no-link'])>.toggle-menu-btn>span>span, .vertical-mega-menu ul.mm-submenu.tree li.mm-hovering>a[onclick]:not([data-href='no-link'])>.toggle-menu-btn>span>span, .vertical-mega-menu ul.mm-submenu.tree li.mega-hover>a[onclick]:not([data-href='no-link'])>.toggle-menu-btn>span>span, .vertical-mega-menu ul.mm-submenu.tabbed>li.mm-hovering>a[onclick]:not([data-href='no-link'])>.toggle-menu-btn>span>span, .vertical-mega-menu ul.mm-submenu.tabbed>li:hover>a[onclick]:not([data-href='no-link'])>.toggle-menu-btn>span>span, .vertical-mega-menu ul.mm-submenu>li>.mega-menu-item-container>.mm-list-name>span[onclick]:hover>span, .vertical-mega-menu ul.mm-submenu>li>.mega-menu-item-container .mm-list-info>a[onclick]:not([data-href='no-link']):hover>*",
            attribute: "color"
        },
        vertical_font_size: {
            element: ".vertical-mega-menu ul.mm-submenu,.vertical-mega-menu ul.mm-submenu span, .vertical-mega-menu ul.mm-submenu.simple>li ul.mm-product-list>li .mm-list-info",
            attribute: "font-size"
        },
        vertical_price_color: {
            element: ".vertical-mega-menu ul.mm-submenu.simple > li .mega-menu-prices span.mega-menu-price span",
            attribute: "color"
        },
        font_family: {
            element: ".horizontal-mega-menu ul.mm-submenu,.horizontal-mega-menu ul.mm-submenu li a,.horizontal-mega-menu ul.mm-submenu a>.mm-title,.horizontal-mega-menu ul.mm-submenu .mm-title,.horizontal-mega-menu ul.mm-submenu a,.horizontal-mega-menu ul.mm-submenu li.mm-contact-column span",
            attribute: "font-family"
        },
        vertical_font_family: {
            element: ".vertical-mega-menu ul.mm-submenu,.vertical-mega-menu ul.mm-submenu li a,.vertical-mega-menu ul.mm-submenu a,.vertical-mega-menu ul.mm-submenu a>.mm-title,.vertical-mega-menu ul.mm-submenu .mm-title,.vertical-mega-menu ul.mm-submenu li.mm-contact-column span",
            attribute: "font-family"
        },
        contact_right_btn_bg_color: {
            element: ".horizontal-mega-menu ul.mm-submenu li.mm-contact-column button",
            attribute: "background"
        },
        contact_right_btn_text_color: {
            element: ".horizontal-mega-menu ul.mm-submenu li.mm-contact-column button",
            attribute: "color"
        },
        countdown_color: {
            element: ".horizontal-mega-menu .buddha-menu-item-countdown .inn",
            attribute: "color"
        },
        countdown_background_color: {
            element: ".horizontal-mega-menu .buddha-menu-item-countdown .inn,.horizontal-mega-menu .buddha-menu-item-countdown .up::after,.horizontal-mega-menu .buddha-menu-item-countdown .flip-clock-dot",
            attribute: "background"
        },
        addtocart_text_color: {
            element: ".horizontal-mega-menu .mm-add-to-cart>div",
            attribute: "color"
        },
        addtocart_text_hover_color: {
            element: ".horizontal-mega-menu .buddha-menu-item .mm-submenu .mm-add-to-cart>div:hover",
            attribute: "color"
        },
        addtocart_background_color: {
            element: ".horizontal-mega-menu .mm-add-to-cart>div",
            attribute: "background"
        },
        addtocart_background_hover_color: {
            element: ".horizontal-mega-menu .buddha-menu-item .mm-submenu .mm-add-to-cart>div:hover",
            attribute: "background"
        },
        vertical_contact_right_btn_bg_color: {
            element: ".vertical-mega-menu .buddha-menu-item ul.mm-submenu li.mm-contact-column button",
            attribute: "background"
        },
        vertical_contact_right_btn_text_color: {
            element: ".vertical-mega-menu ul.mm-submenu li.mm-contact-column button",
            attribute: "color"
        },
        vertical_countdown_color: {
            element: ".vertical-mega-menu .buddha-menu-item-countdown .inn",
            attribute: "color"
        },
        vertical_countdown_background_color: {
            element: ".vertical-mega-menu .buddha-menu-item-countdown .inn,.vertical-mega-menu .buddha-menu-item-countdown .up::after,.vertical-mega-menu .buddha-menu-item-countdown .flip-clock-dot",
            attribute: "background"
        },
        vertical_addtocart_text_color: {
            element: ".vertical-mega-menu .buddha-menu-item .mm-add-to-cart>div",
            attribute: "color"
        },
        vertical_addtocart_background_color: {
            element: ".vertical-mega-menu .buddha-menu-item .mm-add-to-cart>div",
            attribute: "background"
        },
        label_text_color_sale: {
            element: ".horizontal-mega-menu .buddha-menu-item .mm-label.sale",
            attribute: "color"
        },
        label_text_color_new: {
            element: ".horizontal-mega-menu .buddha-menu-item .mm-label.new",
            attribute: "color"
        },
        label_text_color_hot: {
            element: ".horizontal-mega-menu .buddha-menu-item .mm-label.hot",
            attribute: "color"
        },
        label_text_color_all: {
            element: ".horizontal-mega-menu .buddha-menu-item .mm-label.sale,.horizontal-mega-menu .buddha-menu-item .mm-label.new,.horizontal-mega-menu .buddha-menu-item .mm-label.hot",
            attribute: "color"
        },
        label_background_color_sale: {
            element: ".horizontal-mega-menu .buddha-menu-item .mm-label.sale",
            attribute: "background-color"
        },
        label_background_color_new: {
            element: ".horizontal-mega-menu .buddha-menu-item .mm-label.new",
            attribute: "background-color"
        },
        label_background_color_hot: {
            element: ".horizontal-mega-menu .buddha-menu-item .mm-label.hot",
            attribute: "background-color"
        },
        label_background_color_all: {
            element: ".horizontal-mega-menu .buddha-menu-item .mm-label.sale,.horizontal-mega-menu .buddha-menu-item .mm-label.new,.horizontal-mega-menu .buddha-menu-item .mm-label.hot",
            attribute: "background-color"
        },
        vertical_label_text_color_sale: {
            element: ".vertical-mega-menu .buddha-menu-item .mm-label.sale",
            attribute: "color"
        },
        vertical_label_text_color_new: {
            element: ".vertical-mega-menu .buddha-menu-item .mm-label.new",
            attribute: "color"
        },
        vertical_label_text_color_hot: {
            element: ".vertical-mega-menu .buddha-menu-item .mm-label.hot",
            attribute: "color"
        },
        vertical_label_text_color_all: {
            element: ".vertical-mega-menu .buddha-menu-item .mm-label.sale,.vertical-mega-menu .buddha-menu-item .mm-label.new,.vertical-mega-menu .buddha-menu-item .mm-label.hot",
            attribute: "color"
        },
        vertical_label_background_color_sale: {
            element: ".vertical-mega-menu .buddha-menu-item .mm-label.sale",
            attribute: "background-color"
        },
        vertical_label_background_color_new: {
            element: ".vertical-mega-menu .buddha-menu-item .mm-label.new",
            attribute: "background-color"
        },
        vertical_label_background_color_hot: {
            element: ".vertical-mega-menu .buddha-menu-item .mm-label.hot",
            attribute: "background-color"
        },
        vertical_label_background_color_all: {
            element: ".vertical-mega-menu .buddha-menu-item .mm-label.sale,.vertical-mega-menu .buddha-menu-item .mm-label.new,.vertical-mega-menu .buddha-menu-item .mm-label.hot",
            attribute: "background-color"
        }
    }, liveDesign = function(e, t) {
        try {
            if (-1 !== e.indexOf("main_menu_item_size_")) {
                var n = e.replace("main_menu_item_size_", "");
                (m = document.querySelector('.horizontal-mega-menu>li.mega-hover[itemId="' + n + '"]')) && ("auto" == t ? (m.removeAttribute("submenu-size"),
                delete submenuSizes[n],
                null == m.querySelector(".mm-contact") ? setSubmenuBoundries(m) : setContactSubmenuBoundries(m)) : (t = parseInt(t),
                m.setAttribute("submenu-size", t),
                submenuSizes[n] = t,
                null == m.querySelector(".mm-contact") ? setSubmenuBoundries(m, t) : setContactSubmenuBoundries(m, t)))
            } else if (-1 !== e.indexOf("main_menu_item_columns_")) {
                var m;
                n = e.replace("main_menu_item_columns_", "");
                (m = document.querySelector('.horizontal-mega-menu>li.mega-hover[itemId="' + n + '"]')) && ("auto" == t ? (m.removeAttribute("submenu-columns"),
                delete submenuColumns[n],
                null == m.querySelector(".mm-contact") ? setSubmenuBoundries(m) : setContactSubmenuBoundries(m)) : (m.setAttribute("submenu-columns", t),
                submenuColumns[n] = t,
                null == m.querySelector(".mm-contact") ? setSubmenuBoundries(m) : setContactSubmenuBoundries(m)))
            } else {
                var o = "";
                void 0 !== propSettings[e] && (o += propSettings[e].element + "{" + propSettings[e].attribute + ":" + t + " !important; }"),
                o += customPropSettingsStyles(e, t),
                mmAddStyle(o, "tempStyle")
            }
        } catch (e) {
            mmErrorLog(e)
        }
    }, updateDesign = function(e, t) {
        try {
            if (mmRemove("#tempStyle"),
            -1 === e.indexOf("main_menu_item_size_") && -1 === e.indexOf("main_menu_item_columns_") || "auto" != t)
                (o = {}).action = "design",
                o.setting = e,
                o.value = t,
                defaultFontSelected = !1,
                "font_family" == o.setting && "Default" == o.value && (defaultFontSelected = !0),
                mmSchemaDesignJSON.push(o),
                undo.push(o);
            else {
                for (var n = [], m = mmSchemaDesignJSON.length - 1; m >= 0; m--) {
                    var o = mmSchemaDesignJSON[m];
                    "design" == o.action && o.setting == e || n.push(o)
                }
                mmSchemaDesignJSON = n
            }
            if (recreateDesign(e),
            "font_size" != e && "font_family" != e && -1 === e.indexOf("main_menu_item_columns_") || mmForEach(document, ".horizontal-mega-menu>.buddha-menu-item.mega-hover>.mm-submenu", (function(t) {
                if (parseInt(window.getComputedStyle(t).getPropertyValue("top")) > 0) {
                    var n = 10;
                    "font_family" != e && "font_size" != e || (n = 300),
                    setTimeout((function() {
                        setSubmenuBoundries(t.parentElement),
                        setContactSubmenuBoundries(t.parentElement),
                        t.matches(".tabbed") && setTabbedSubmenuBoundries(t.querySelector("li.tab-opened"))
                    }
                    ), n)
                }
            }
            )),
            -1 !== e.indexOf("main_menu_item_columns_")) {
                var a = e.replace("main_menu_item_columns_", "")
                  , i = document.querySelector('.horizontal-mega-menu>li.mega-hover[itemId="' + a + '"]');
                i && i.querySelector(".mm-submenu.tabbed") && (o.type = "tabbed")
            }
            if (redo = [],
            window.self !== window.top) {
                var r = parent;
                void 0 === parent.postMessage && (r = top),
                r.postMessage(["updateToolbar", JSON.stringify(mmSchemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "*")
            } else
                previewPanelLoaded && document.getElementById("mega-menu-iframe").contentWindow.postMessage(["updateToolbar", JSON.stringify(mmSchemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "https://buddhaapps.com")
        } catch (e) {
            mmErrorLog(e)
        }
    }, recreateDesign = function(e) {
        var t = ""
          , n = [];
        if (window.self === window.top && "undefined" == typeof mmSettingsPage || void 0 === e)
            n = mmSchemaDesignJSON;
        else
            for (var m = [], o = mmSchemaDesignJSON.length - 1; o >= 0; o--) {
                "design" == (a = mmSchemaDesignJSON[o]).action && -1 == m.indexOf(a.setting) ? (m[m.length] = a.setting,
                n.push(a)) : "menu-select" == a.action && n.push(a)
            }
        for (o = 0; o < n.length; o++) {
            var a;
            if ("design" == (a = n[o]).action && null != propSettings[a.setting])
                "font_size" == a.setting ? fontSize = parseInt(a.value) : "font_family" == a.setting ? (mmRemove("#googleFontDesign"),
                "Default" != a.value && "Arial" != a.value && "Georgia" != a.value && "Tahoma" != a.value && "Trebuchet MS" != a.value && "Times New Roman" != a.value && "Verdana" != a.value && mmAddLink("//fonts.googleapis.com/css?family=" + a.value, "googleFontDesign")) : "vertical_font_family" == a.setting ? (mmRemove("#googleFontDesignVertical"),
                "Default" != a.value && "Arial" != a.value && "Georgia" != a.value && "Tahoma" != a.value && "Trebuchet MS" != a.value && "Times New Roman" != a.value && "Verdana" != a.value && mmAddLink("//fonts.googleapis.com/css?family=" + a.value, "googleFontDesignVertical")) : "text_color" == a.setting ? livIconsOptions.horizontalColor = a.value : "link_hover_color" == a.setting ? livIconsOptions.horizontalHover = a.value : "background_image_text_color" == a.setting ? livIconsOptions.horizontalBackgroundImageColor = a.value : "vertical_text_color" == a.setting ? livIconsOptions.verticalColor = a.value : "vertical_link_hover_color" == a.setting && (livIconsOptions.verticalHover = a.value),
                ("font_family" != a.setting || "font_family" == a.setting && !defaultFontSelected && "Default" != a.value) && (t += propSettings[a.setting].element + "{" + propSettings[a.setting].attribute + ": " + a.value + " !important; }");
            else if ("design" == a.action && -1 !== a.setting.indexOf("main_menu_item_direction_")) {
                var i = a.setting.replace("main_menu_item_direction_", "")
                  , r = document.querySelector('.horizontal-mega-menu>li.mega-hover[itemId="' + i + '"]');
                r && (r.setAttribute("submenu-direction", a.value),
                submenuDirections[i] = a.value,
                window.self === window.top && "undefined" == typeof mmSettingsPage || (null == r.querySelector(".mm-contact") ? setSubmenuBoundries(r, !1, a.value) : setContactSubmenuBoundries(r, !1, a.value)))
            }
            "design" == a.action && (t += customPropSettingsStyles(a.setting, a.value))
        }
        if (mmAddStyle(t, "previewStyle"),
        mmLivIcons && (window.self !== window.top || "undefined" != typeof mmSettingsPage) && void 0 !== typeof e && "text_color,link_hover_color,vertical_text_color,vertical_link_hover_color,background_image_text_color,".indexOf(e + ",") >= 0)
            for (o = 0; o < mmMenuUls.length; o++)
                void 0 === livIconsOptionsCache[o] && (livIconsOptionsCache[o] = {
                    opt: "",
                    optMain: "",
                    optBg: ""
                }),
                addUpdateLivIcons(mmMenuUls[o])
    }, mmEvtMouseEnterPreview = function(e) {
        var t = e.target;
        if (t.matches(".horizontal-mega-menu>.buddha-menu-item") && (mmForEach(document, ".mega-hover", (function(e) {
            e.classList.remove("mega-hover")
        }
        )),
        panelOpened && (t.classList.add("mega-hover"),
        window.self !== window.top))) {
            var n = parent;
            void 0 === parent.postMessage && (n = top);
            var m = t.getAttribute("itemId");
            n.postMessage(["updateMainMenuItemSelect", m], "*")
        }
    }, designPanelOpened = function(e) {
        var t = null
          , n = null;
        if (mmForEach(document, ".horizontal-mega-menu", (function(e) {
            if (mmIsVisible(e))
                return n = e,
                -1
        }
        )),
        n) {
            if (e && void 0 !== e) {
                if ("custom_addtocart" == e) {
                    var m = 0;
                    e = null,
                    mmForEach(n, ".buddha-menu-item", (function(n) {
                        var o = n.querySelectorAll(".mm-add-to-cart").length;
                        o > m && (m = o,
                        e = n.getAttribute("itemId"),
                        t = n.querySelector(".mm-add-to-cart").closest(".mm-submenu.tabbed>li"))
                    }
                    ))
                } else if ("custom_labels" == e) {
                    m = 0;
                    e = null,
                    mmForEach(n, ".buddha-menu-item", (function(n) {
                        var o = n.querySelectorAll(".mm-label").length;
                        o > m && (m = o,
                        e = n.getAttribute("itemId"),
                        t = n.querySelector(".mm-label").closest(".mm-submenu.tabbed>li"))
                    }
                    ))
                } else if ("custom_contact" == e) {
                    (l = n.querySelector(".mm-contact")) && (e = l.closest(".buddha-menu-item").getAttribute("itemId"))
                } else if ("custom_fonts" == e) {
                    var o = n.querySelector(".mm-submenu.simple");
                    null == o && (o = n.querySelector(".mm-submenu")),
                    o && (e = o.closest(".buddha-menu-item").getAttribute("itemId"))
                } else if ("price_color" == e) {
                    var a = n.querySelector(".mega-menu-prices");
                    a && (e = a.closest(".buddha-menu-item").getAttribute("itemId"))
                }
                if (e && null != typeof e) {
                    var i = n.querySelector('.buddha-menu-item[itemId="' + e + '"]');
                    if (i && !i.matches(".mega-hover") && (mmForEach(document, ".mega-hover", (function(e) {
                        e.classList.remove("mega-hover")
                    }
                    )),
                    i.classList.add("mega-hover"),
                    window.self !== window.top)) {
                        var r = parent;
                        void 0 === parent.postMessage && (r = top),
                        r.postMessage(["updateMainMenuItemSelect", e, "true"], "*")
                    }
                }
            } else {
                panelOpened = !0;
                var u = n.querySelector(".buddha-menu-item>ul.mm-submenu.tabbed");
                if (u)
                    u.parentElement.classList.add("mega-hover");
                else {
                    var l, s = n.querySelector(".buddha-menu-item>ul.mm-submenu.simple");
                    if (s)
                        s.parentElement.classList.add("mega-hover");
                    else if (l = n.querySelector(".buddha-menu-item>ul.mm-submenu.contact"))
                        l.parentElement.classList.add("mega-hover");
                    else {
                        var c = n.querySelector(".buddha-menu-item>ul.mm-submenu.tree");
                        c && c.parentElement.classList.add("mega-hover")
                    }
                }
            }
            var d = document.querySelector(".buddha-menu-item.mega-hover");
            if (d) {
                if (setSubmenuBoundries(d),
                setContactSubmenuBoundries(d),
                t)
                    mmForEach(t.parentElement, ".tab-opened", (function(e) {
                        e.classList.remove("tab-opened")
                    }
                    )),
                    t.classList.add("tab-opened"),
                    setTabbedSubmenuBoundries(t);
                else {
                    var g = n.querySelector("ul.mm-submenu.tabbed>li.tab-opened");
                    if (g)
                        setTabbedSubmenuBoundries(g);
                    else {
                        var p = n.querySelector("ul.mm-submenu.tabbed>li");
                        p && (p.classList.add("tab-opened"),
                        setTabbedSubmenuBoundries(p))
                    }
                }
                if (!e && window.self !== window.top) {
                    r = parent;
                    void 0 === parent.postMessage && (r = top);
                    var h = d.getAttribute("itemId");
                    r.postMessage(["updateMainMenuItemSelect", h], "*")
                }
            }
        }
        mmForEach(document, ".horizontal-mega-menu>.buddha-menu-item", (function(e) {
            e.removeEventListener("mouseenter", mmEvtMouseEnterPreview),
            e.addEventListener("mouseenter", mmEvtMouseEnterPreview)
        }
        ))
    };
    window.addEventListener("message", (function(e) {
        (~e.origin.indexOf("megamenu.buddhaapps.com") || ~e.origin.indexOf("https://megamenu-new") || ~e.origin.indexOf("https://megamenu-dev")) && ("object" == typeof e.data ? "applyMegaMenu" == e.data[0] ? (window[e.data[0]](e.data[1]),
        applyOnClick()) : -1 !== ["undoAction", "redoAction", "clearAction", "initSaving", "designPanelClosed"].indexOf(e.data[0]) ? window[e.data[0]]() : "designPanelOpened" == e.data[0] ? void 0 === e.data[1] ? window[e.data[0]]() : window[e.data[0]](e.data[1]) : -1 !== ["liveDesign", "updateDesign"].indexOf(e.data[0]) && window[e.data[0]](e.data[1], e.data[2]) : "string" == typeof e.data && "function" == typeof window[e.data] && window[e.data]())
    }
    ));
    var initSaving = function() {
        saving = !0
    }
      , slideUpTransition = function(e) {
        for (var t = parseInt(e.style.maxHeight), n = mmParents(e), m = 0; m < n.length; m++)
            n[m].matches("ul.mm-submenu") && (n[m].style.maxHeight = parseInt(n[m].style.maxHeight) - t + "px");
        var o = e.closest("li");
        o && mmForEach(o, ".mm-submenu", (function(e) {
            e.style.maxHeight = 0,
            e.style.marginBottom = 0
        }
        ))
    }
      , slideDownTransition = function(e) {
        var t = parseInt(e.scrollHeight) + 50;
        e.style.maxHeight = t + "px",
        e.closest("li").matches(":last-child") && (e.style.marginBottom = "-5px");
        for (var n = mmParents(e), m = 0; m < n.length; m++)
            n[m].matches(".mm-submenu") && (n[m].style.maxHeight = parseInt(n[m].style.maxHeight) + t + "px")
    }
      , mmEvtToggleSubmenu = document.createEvent("Event");
    mmEvtToggleSubmenu.initEvent("toggleSubmenu", !0, !0);
    var setSubmenuSpacing = function(e) {
        var t = 0
          , n = e.getAttribute("columns");
        n = null == n ? 1 : parseInt(n);
        var m = 0
          , o = !0;
        mmForEachChild(e, "LI", (function(e) {
            var a = e.getAttribute("item-type")
              , i = e.getAttribute("submenu-columns");
            i = null == i ? 1 : parseInt(i),
            e.classList.remove("mm-left-item"),
            e.classList.remove("mm-right-item"),
            m += i >= n ? n : i,
            2 == n && 1 == i && null != a && -1 != ["best-sellers", "newest-products", "link-list", "link-list-image"].indexOf(a) && (m += 1),
            null != e.closest(".mm-submenu.tree") && (m += 1);
            var r = e.nextElementSibling;
            if (r) {
                var u = r.getAttribute("item-type")
                  , l = r.getAttribute("submenu-columns");
                l = null == l ? 1 : parseInt(l),
                2 == n && 1 == l && null != u && -1 != ["best-sellers", "newest-products", "link-list", "link-list-image"].indexOf(u) && (l += 1),
                m + l > n && (m = n)
            }
            setTimeout((function() {
                e.classList.add("mmBounceInUp")
            }
            ), t),
            null != e.closest(".mm-submenu.simple") && (m - n == 0 && e.classList.add("mm-right-item"),
            o && (e.classList.add("mm-left-item"),
            o = !1),
            m - n == 0 && (t += 150,
            m = 0,
            o = !0))
        }
        ))
    }, toggleSubmenu = function(e) {
        try {
            if (!submenuToggled) {
                submenuToggled = !0,
                setTimeout((function() {
                    submenuToggled = !1
                }
                ), 300),
                e.matches(".toggle-menu-btn") || (e = e.querySelector(".toggle-menu-btn"));
                var t = e.closest("li");
                if (t) {
                    var n = e.closest(".vertical-mega-menu")
                      , m = t.querySelector("ul.mm-submenu:not(.hide-menu)");
                    if (m && n) {
                        var o;
                        if (m.classList.contains("submenu-opened"))
                            o = n.clientHeight - parseInt(m.scrollHeight),
                            slideUpTransition(m),
                            mmForEach(t, ".toggle-menu-btn>span", (function(e) {
                                e.classList.remove("mm-cross")
                            }
                            )),
                            setTimeout((function() {
                                mmForEach(t, ".mm-hovering", (function(e) {
                                    e.classList.remove("mm-hovering")
                                }
                                )),
                                t.classList.remove("mm-hovering"),
                                mmForEach(t, ".submenu-opened", (function(e) {
                                    e.classList.remove("submenu-opened")
                                }
                                )),
                                mmForEach(m, ".mmBounceInUp", (function(e) {
                                    e.classList.remove("mmBounceInUp")
                                }
                                ))
                            }
                            ), 600);
                        else {
                            t.classList.add("mm-hovering");
                            var a = e.querySelector("span");
                            a && a.classList.add("mm-cross"),
                            m.classList.add("submenu-opened"),
                            m.classList.add("height-transition");
                            m.matches(".simple") && (setSubmenuBoundries(t),
                            setTimeout((function() {
                                setSubmenuBoundries(t)
                            }
                            ), 500)),
                            o = n.clientHeight + parseInt(m.scrollHeight) + 50,
                            slideDownTransition(m),
                            setTimeout((function() {
                                a.classList.contains("mm-cross") && slideDownTransition(m)
                            }
                            ), 600),
                            setSubmenuSpacing(m)
                        }
                        mmEvtToggleSubmenu.mmMobileHeight = o,
                        mmEvtToggleSubmenu.mmSubmenu = m,
                        document.dispatchEvent(mmEvtToggleSubmenu)
                    }
                }
            }
        } catch (e) {
            mmErrorLog(e)
        }
        return "undefined" != typeof event && event.stopImmediatePropagation(),
        !1
    }, initClickToggle = function() {
        document.addEventListener("click", (function(e) {
            null == e.target.closest(".buddha-menu-item") && mmForEach(document, ".mm-click-toggle .buddha-menu-item.mega-hover", (function(e) {
                e.classList.remove("mega-hover")
            }
            ))
        }
        )),
        window.mmAddHover = function(e) {
            if (null != e.target.closest(".mm-submenu.tree")) {
                for (var t = (m = e.target.closest("li")).parentElement.querySelectorAll(".mega-hover"), n = 0; n < t.length; n++)
                    t[n].classList.remove("mega-hover");
                m.classList.add("mega-hover")
            } else if (e.target.closest(".mm-submenu.tabbed>li")) {
                var m = e.target.closest("li");
                mmForEach(m.parentNode, ".tab-opened", (function(e) {
                    e.classList.remove("tab-opened")
                }
                )),
                m.classList.add("tab-opened"),
                setTabbedSubmenuBoundries(m)
            } else
                mmForEach(document, ".buddha-menu-item.mega-hover", (function(e) {
                    e.classList.remove("mega-hover")
                }
                )),
                e.target.closest(".buddha-menu-item").classList.add("mega-hover")
        }
    }, mmGoToPage = function(e, t) {
        if (!changingPage && !submenuToggled && !mmTouchMoved) {
            var n = window.location.hostname.replace("www.", "")
              , m = n.substr(0, n.indexOf(".")) + "."
              , o = e.getAttribute("data-href");
            if (o && "no-link" != o)
                if (-1 !== o.indexOf("http") && -1 === o.indexOf(m) && -1 === o.indexOf("myshopify.com")) {
                    changingPage = !0;
                    var a = window.open(o, "_blank");
                    a && a.focus(),
                    setTimeout((function() {
                        changingPage = !1
                    }
                    ), 300)
                } else
                    changingPage = !0,
                    window.location = o,
                    setTimeout((function() {
                        changingPage = !1
                    }
                    ), 1e3);
            else
                t.stopPropagation()
        }
        return !1
    }, getImgUrlLowRes = function(e, t) {
        if (null == e)
            return "";
        var n = {
            ".jpg": "_" + t + ".jpg",
            ".JPG": "_" + t + ".JPG",
            ".png": "_" + t + ".png",
            ".PNG": "_" + t + ".PNG"
        };
        for (key in n) {
            var m = e.lastIndexOf(key);
            -1 != m && (e = e.substring(0, m) + n[key] + e.substring(m + key.length))
        }
        return e
    }, mmAddToCartPopup = function(e, t) {
        switch (e) {
        case "hide":
            document.querySelector(".mm-atc-popup").style.removeProperty("opacity"),
            document.querySelector(".mm-atc-popup").style.removeProperty("pointer-events"),
            setTimeout((function() {
                document.querySelector(".mm-atc-popup").style.removeProperty("display")
            }
            ), 1e3);
            break;
        case "show":
            document.querySelector(".mm-atc-popup").style.setProperty("display", "flex", "important"),
            setTimeout((function() {
                document.querySelector(".mm-atc-popup").style.setProperty("opacity", 1, "important"),
                document.querySelector(".mm-atc-popup").style.setProperty("pointer-events", "auto", "important")
            }
            ), 20);
            break;
        case "setproduct":
            var n = getImgUrlLowRes(t.items[0].image, "70x");
            document.querySelector(".mm-atc-popup .mm-atc-head>span").innerHTML = mmAtcPopupSuccess,
            document.querySelector(".mm-atc-popup .mm-atc-view-cart").innerHTML = mmAtcPopupViewCart,
            "" != n ? (document.querySelector(".mm-atc-popup .mm-atc-product-image").src = n,
            document.querySelector(".mm-atc-popup .mm-atc-product-image").style.setProperty("display", "block"),
            document.querySelector(".mm-atc-popup .mm-atc-product>div").style.removeProperty("padding")) : (document.querySelector(".mm-atc-popup .mm-atc-product-image").style.setProperty("display", "none"),
            document.querySelector(".mm-atc-popup .mm-atc-product>div").style.setProperty("padding", "0")),
            document.querySelector(".mm-atc-popup .mm-atc-product").setAttribute("href", t.items[0].url),
            document.querySelector(".mm-atc-popup .mm-atc-product-name").innerHTML = t.items[0].product_title,
            document.querySelector(".mm-atc-popup .mm-atc-product-variant").innerHTML = t.items[0].variant_title,
            "undefined" != typeof mmAddToCartPopupCallback && mmAddToCartPopupCallback();
            break;
        case "error":
            document.querySelector(".mm-atc-popup .mm-atc-head>span").innerHTML = mmAtcPopupOutOfStock,
            document.querySelector(".mm-atc-popup .mm-atc-product-image").style.setProperty("display", "none"),
            document.querySelector(".mm-atc-popup .mm-atc-product>div").style.setProperty("padding", "0"),
            document.querySelector(".mm-atc-popup .mm-atc-product-name").innerHTML = t.description,
            document.querySelector(".mm-atc-popup .mm-atc-product-variant").innerHTML = ""
        }
    }, mmAddToCartTimeout, mmAddToCart = function(e) {
        var t = e.getAttribute("varid");
        if (t) {
            clearTimeout(mmAddToCartTimeout);
            var n = new XMLHttpRequest;
            n.open("POST", "/cart/add.js", !0),
            n.setRequestHeader("Content-Type", "application/json;charset=UTF-8"),
            n.onreadystatechange = function() {
                4 == n.readyState && (200 == n.status ? "undefined" != typeof HsCartDrawer ? HsCartDrawer.getSlideCart() : "undefined" != typeof mmAddToCartAfter ? mmAddToCartAfter(JSON.parse(n.responseText)) : (mmAddToCartPopup("setproduct", JSON.parse(n.responseText)),
                mmAddToCartPopup("show"),
                mmAddToCartTimeout = setTimeout((function() {
                    mmAddToCartPopup("hide")
                }
                ), 6e3)) : (mmAddToCartPopup("error", JSON.parse(n.responseText)),
                mmAddToCartPopup("show"),
                mmAddToCartTimeout = setTimeout((function() {
                    mmAddToCartPopup("hide")
                }
                ), 6e3)))
            }
            ;
            var m = {
                items: [{
                    quantity: 1,
                    id: t
                }]
            }
              , o = e.getAttribute("sellingplan");
            "" != o && (m.items[0].selling_plan = o),
            n.send(JSON.stringify(m))
        }
        "undefined" != typeof buddhaCrosssell && void 0 !== buddhaCrosssell.upsellPopup && setTimeout((function() {
            buddhaCrosssell.upsellPopup("show")
        }
        ), 1e3)
    }, setImagePlaceholderSize = function(e) {
        var t = e.getAttribute("columns");
        t = t || 1;
        var n = e.offsetWidth / t - 30;
        mmForEach(e, ".mm-image img", (function(e) {
            if ("" == e.style.width && "" == e.closest(".mm-image").style.width && !e.matches(".mmLazyloaded")) {
                var t = e.closest("li[image-type]");
                if (t || (t = e.closest("li")),
                t) {
                    var m = e.getAttribute("aspect-ratio");
                    null != m && 0 != m || (m = 30);
                    var o = t.getAttribute("submenu-columns")
                      , a = (t.getAttribute("image-type"),
                    n * (o = o || 1))
                      , i = a / m;
                    e.style.width = a + "px",
                    e.style.height = i + "px";
                    var r = e.closest(".mm-image");
                    r && (r.style.height = i + "px");
                    var u = e.closest(".mm-image-container");
                    u && u.style.removeProperty("height");
                    var l = t.querySelector(".mm-label");
                    l && l.classList.add("mmHidden")
                }
            }
        }
        ))
    }, setImageContainerDimensions = function(e) {
        var t = e.querySelector(".mm-image-container img");
        if (t) {
            var n = e.querySelector(".mm-image-container")
              , m = e.querySelector(".mm-image")
              , o = e.getAttribute("image-type");
            if (n && m && o) {
                var a = null != e.closest(".vertical-mega-menu")
                  , i = t.naturalWidth
                  , r = t.naturalHeight;
                if (0 !== i && 0 !== r) {
                    if (t.removeAttribute("style"),
                    n.removeAttribute("style"),
                    m.removeAttribute("style"),
                    o.indexOf("crop-") >= 0) {
                        var u = "high"
                          , l = "";
                        o.indexOf("-full") >= 0 && (l = "-full"),
                        i > r && (u = "wide"),
                        o = "crop-" + u + l,
                        e.setAttribute("image-type", o)
                    }
                    var s = (g = o.indexOf("-full") >= 0 ? n.getBoundingClientRect() : m.getBoundingClientRect()).width
                      , c = g.height;
                    if (0 != s && 0 != c) {
                        if (o.indexOf("fit-") >= 0) {
                            var d;
                            if (r > c)
                                i /= d = r / c,
                                r /= d;
                            if (i > s)
                                i /= d = i / s,
                                r /= d
                        }
                        if (o.indexOf("crop-") >= 0) {
                            var g, p = !1, h = s / c, b = i / r;
                            if (b > 3 && a && (i / 2 > s && r / 2 >= 40 ? (r /= 2,
                            i /= 2) : i / 1.5 > s && r / 1.5 >= 40 && (r /= 1.5,
                            i /= 1.5)),
                            i > s && (i = s),
                            r > c && (r = c),
                            b < .9 || b > 1.1 ? h > b ? "crop-wide-full" == o ? (e.setAttribute("image-type", "crop-high-full"),
                            p = !0) : "crop-wide" == o && (e.setAttribute("image-type", "crop-high"),
                            p = !0) : h < b && ("crop-high-full" == o ? (e.setAttribute("image-type", "crop-wide-full"),
                            p = !0) : "crop-high" == o && (e.setAttribute("image-type", "crop-wide"),
                            p = !0)) : "crop-wide-full" == o ? (e.setAttribute("image-type", "crop-high-full"),
                            p = !0) : "crop-wide" == o && (e.setAttribute("image-type", "crop-high"),
                            p = !0),
                            p)
                                b = (i = t.naturalWidth) / (r = t.naturalHeight),
                                s = (g = o.indexOf("-full") >= 0 ? n.getBoundingClientRect() : m.getBoundingClientRect()).width,
                                b > 3 && a && (i / 2 > s && r / 2 >= 40 ? (r /= 2,
                                i /= 2) : i / 1.5 > s && r / 1.5 >= 40 && (r /= 1.5,
                                i /= 1.5)),
                                i > s && (i = s),
                                r > (c = g.height) && (r = c)
                        }
                        m.style.width = i + "px",
                        m.style.height = r + "px";
                        var f = e.querySelector(".mm-image-container>.mm-label-wrap")
                          , v = e.querySelector(".mm-description");
                        f && (f.style.width = i + "px",
                        f.style.height = r + "px"),
                        v && (v.style.width = i + "px")
                    }
                }
            }
        } else
            setImageContainerDimensionsVideo(e)
    }, setImageContainerDimensionsVideo = function(e) {
        var t = e.querySelector(".mm-image-container .mm-video-player")
          , n = e.querySelector(".mm-image-container .mm-image");
        if (t && n) {
            t.removeAttribute("style"),
            n.removeAttribute("style");
            var m = t.getBoundingClientRect()
              , o = Math.ceil(m.width)
              , a = Math.ceil(m.height)
              , i = parseInt(n.offsetHeight);
            if (0 !== o && 0 !== a) {
                a > i && (a = i),
                n.style.width = o + "px",
                n.style.height = a + "px";
                var r = e.querySelector(".mm-image-container>.mm-label-wrap")
                  , u = e.querySelector(".mm-description");
                r && (r.style.width = o + "px",
                r.style.height = a + "px"),
                u && (u.style.width = o + "px")
            }
        }
    }, setSubmenuRowItemsHeight = function(e, t) {
        var n = 5
          , m = null != e.closest(".vertical-mega-menu");
        if (m)
            n = t;
        else if (e.parentNode && e.parentNode.matches(".mm-submenu.tabbed[columns]"))
            n = e.parentNode.getAttribute("columns") - 1;
        else {
            var o = e.querySelector("ul.mm-submenu.simple[columns]:not(.hide-menu)");
            o && (n = o.getAttribute("columns"))
        }
        if (n > 1) {
            mmForEach(e, "ul.mm-submenu>li .mm-featured-title, ul.mm-submenu>li .mm-list-name, ul.mm-submenu>li .mega-menu-prices", (function(e) {
                e.removeAttribute("style")
            }
            ));
            var a = 0
              , i = []
              , r = []
              , u = []
              , l = []
              , s = {}
              , c = {}
              , d = {}
              , g = 0
              , p = e.querySelector(".mm-submenu:not(.hide-menu)");
            p && mmForEachChild(p, "LI", (function(e) {
                var o = e.getAttribute("item-type")
                  , p = e.getAttribute("image-type")
                  , h = e.getAttribute("submenu-columns");
                if (h = null == h ? 1 : parseInt(h),
                m ? (a += h >= n ? n : h,
                2 == t && 1 == a && null != o && -1 != ["best-sellers", "newest-products", "link-list", "link-list-image"].indexOf(o) && (a += 1)) : a += h,
                void 0 === s[h] && (s[h] = 0),
                void 0 === c[h] && (c[h] = 0),
                void 0 === d[h] && (d[h] = 0),
                o && p && -1 != ["featured-product", "featured-collection", "featured-article", "featured-custom", "video"].indexOf(o) && -1 == ["fit-high-full", "fit-wide-full", "crop-high-full", "crop-wide-full"].indexOf(p)) {
                    var b = e.querySelector(".mm-featured-title");
                    if (b) {
                        var f = b.offsetHeight;
                        c[h] < f && (c[h] = f),
                        r.push([h, b])
                    }
                    var v = e.querySelector(".mm-image-container");
                    v && (itemImageHeight = v.offsetHeight,
                    s[h] < itemImageHeight && (s[h] = itemImageHeight),
                    i.push([h, v]));
                    var y = e.querySelector(".mega-menu-prices");
                    if (y) {
                        var S = y.offsetHeight;
                        d[h] < S && (d[h] = S),
                        u.push([h, y])
                    }
                } else {
                    var w = e.querySelector(".mm-list-name");
                    if (w) {
                        var M = w.offsetHeight;
                        M > g && (g = M),
                        l.push(w)
                    }
                }
                var _ = e.nextElementSibling
                  , E = 0;
                if (_ && (E = null == (E = _.getAttribute("submenu-columns")) ? 1 : parseInt(E),
                m)) {
                    var O = _.getAttribute("item-type");
                    (E >= 2 || 2 == t && 1 == E && null !== O && -1 != ["best-sellers", "newest-products", "link-list", "link-list-image"].indexOf(O)) && (E = 2)
                }
                if (a % n == 0 || null == _ || a + E > n) {
                    for (var k = 0; k < i.length; k++)
                        i[k][1].style.height = s[i[k][0]] + "px";
                    for (k = 0; k < r.length; k++)
                        r[k][1].style.minHeight = c[r[k][0]] + "px";
                    for (k = 0; k < u.length; k++)
                        u[k][1].style.height = d[u[k][0]] + "px";
                    for (k = 0; k < l.length; k++)
                        l[k].style.height = g + "px";
                    a = 0,
                    i = [],
                    r = [],
                    u = [],
                    l = [],
                    s = {},
                    c = {},
                    d = {},
                    g = 0
                }
            }
            ))
        }
    }, setSubmenuRowItemsZindex = function(e, t) {
        for (var n = !1, m = 0, o = !1, a = 0, i = 0, r = 1, u = 10, l = mmGetChildren(e, ".mm-submenu:not(.hide-menu)>li"), s = null != e.closest(".vertical-mega-menu"), c = 0; c < l.length; c++) {
            var d = l[c].getAttribute("submenu-columns");
            d = d ? parseInt(d) : 1;
            var g = l[c].getAttribute("item-type");
            s && (d >= 2 || 2 == t && 1 == d && null !== g && -1 != ["best-sellers", "newest-products", "link-list", "link-list-image"].indexOf(g)) && (d = 2),
            i += d,
            n || 1 != r || (n = null !== l[c].getAttribute("haslabel")),
            1 == r && i <= t && (m = c),
            "featured-banner" != g && "featured-custom" != g || -1 == ["crop-high-full", "crop-wide-full"].indexOf(l[c].getAttribute("image-type")) || (o = !0),
            i > t && (i = d,
            o = !1,
            a = c,
            u = 10 * ++r),
            l[c].style.zIndex = u,
            u--
        }
        if (n || !o)
            for (c = 0; c < l.length; c++)
                n && c <= m && l[c].style.setProperty("padding-top", "15px", "important"),
                !o && c >= a && l[c].style.setProperty("margin-bottom", "10px", "important")
    }, setSubmenuImageAndHeightBoundries = function(e, t) {
        setSubmenuRowItemsZindex(e, t);
        for (var n = mmGetChildren(e, ".mm-submenu:not(.hide-menu)>li"), m = 0; m < n.length; m++) {
            null == (o = n[m].getAttribute("image-type")) && null != n[m].querySelector(".mm-image-container img,.mm-image-container .mm-video-player") && (n[m].setAttribute("image-type", "fit-high"),
            o = "fit-high"),
            -1 != ["fit-high", "fit-wide", "crop-high", "crop-wide"].indexOf(o) && setImageContainerDimensions(n[m])
        }
        setSubmenuRowItemsHeight(e, t);
        for (m = 0; m < n.length; m++) {
            var o = n[m].getAttribute("image-type");
            -1 != ["fit-high-full", "fit-wide-full", "crop-high-full", "crop-wide-full"].indexOf(o) && setImageContainerDimensions(n[m])
        }
    }, setSubmenuBoundries = function(e, t, n) {
        try {
            if (null == e || null == e)
                return;
            var m = document.querySelector("body")
              , o = null !== e.getAttribute("submenu-columns")
              , a = 1e3
              , i = 768
              , r = 1e3
              , u = 0;
            m && (r = m.offsetWidth,
            u = m.offsetLeft);
            var l = mmGetChildren(e, ".mm-submenu:not(.hide-menu)", !0);
            if (l) {
                var s = l.matches(".simple")
                  , c = l.matches(".tabbed");
                if (s || c) {
                    if (null != e.closest(".horizontal-mega-menu")) {
                        for (var d = mmParents(e.parentElement), g = 0; g < d.length; g++) {
                            var p = parseInt(window.getComputedStyle(d[g]).getPropertyValue("padding-left"));
                            (O = d[g].getBoundingClientRect().left + p - u) < a && O > 0 && (a = O)
                        }
                        (1e3 == a || r <= 768) && (a = 0);
                        var h, b = e.getAttribute("submenu-columns");
                        if (!t || void 0 === t)
                            (h = e.getAttribute("submenu-size")) && (t = h);
                        if (!n || void 0 === n)
                            (h = e.getAttribute("submenu-direction")) && (n = h);
                        if (customHeaderOffset)
                            a = customHeaderOffset < r ? (r - customHeaderOffset) / 2 : 0;
                        else if (t) {
                            i = 0;
                            null !== b && (5 == b ? i = 1e3 : 4 == b ? i = 800 : 3 == b ? i = 600 : 2 == b && (i = 400)),
                            t < i && (t = i),
                            a = t < r ? (r - t) / 2 : 0
                        }
                        l.style.width = "auto",
                        l.style.left = "auto",
                        l.style.right = "auto",
                        l.style.maxWidth = "none",
                        l.style.minWidth = "auto",
                        disableOnScroll || (l.style.maxHeight = "none"),
                        2 * a > r && (a = 0);
                        var f = r - 2 * a;
                        if (o) {
                            var v = b;
                            if (l.style.setProperty("width", f + "px", "important"),
                            "left" != n && "right" != n || (v > 4 && r < 768 || v > 3 && r < 512 || v > 2 && r < 384) && (n = "auto"),
                            n && void 0 !== n && "auto" != n || (v > 2 && r < 462 ? v = 2 : v > 3 && r < 616 ? v = 3 : v > 4 && r < 768 && (v = 4)),
                            l.setAttribute("columns", v),
                            s) {
                                var y = mmGetChildren(e, "ul.simple>li");
                                for (g = 0; g < y.length; g++) {
                                    var S = y[g].getAttribute("submenu-columns")
                                      , w = y[g].getAttribute("submenu-original-columns");
                                    if (null != S && v < S)
                                        null == (w = y[g].getAttribute("submenu-original-columns")) && (y[g].setAttribute("submenu-original-columns", S),
                                        w = S),
                                        y[g].setAttribute("submenu-columns", v),
                                        S = v;
                                    null != w && v >= S && w > S && (y[g].setAttribute("submenu-columns", v),
                                    w == v && y[g].removeAttribute("submenu-original-columns"))
                                }
                            } else if (c)
                                for (y = mmGetChildren(e, "ul.tabbed>li>ul.simple>li"),
                                g = 0; g < y.length; g++) {
                                    S = y[g].getAttribute("submenu-columns"),
                                    w = y[g].getAttribute("submenu-original-columns");
                                    if (null != S && v - 1 < S)
                                        null == (w = y[g].getAttribute("submenu-original-columns")) && (y[g].setAttribute("submenu-original-columns", S),
                                        w = S),
                                        y[g].setAttribute("submenu-columns", v - 1),
                                        S = v - 1;
                                    null != w && v >= S && w > S && (y[g].setAttribute("submenu-columns", v - 1),
                                    w == v - 1 && y[g].removeAttribute("submenu-original-columns"))
                                }
                        } else {
                            v = 5;
                            ("left" == n || "right" == n) && r < 768 && (n = "auto"),
                            f >= 1020 ? (l.setAttribute("columns", 5),
                            v = 5) : f >= 816 ? (l.setAttribute("columns", 4),
                            v = 4) : f >= 612 ? (l.setAttribute("columns", 3),
                            v = 3) : (l.setAttribute("columns", 2),
                            v = 2),
                            l.style.setProperty("width", f + "px", "important"),
                            l.style.setProperty("min-width", "400px", "important"),
                            5 == v ? i = 1e3 : 4 == v ? i = 800 : 3 == v ? i = 600 : 2 == v && (i = 400)
                        }
                        var M = e.getBoundingClientRect()
                          , _ = M.left
                          , E = M.width
                          , O = _ - u + E / 2;
                        if (n && void 0 !== n && "auto" != n) {
                            if ("right" == n) {
                                p = parseInt(window.getComputedStyle(e).getPropertyValue("padding-left"));
                                var k = 0;
                                (A = r - (_ + p)) < i && (k = i - A),
                                l.style.left = -k + "px",
                                l.style.maxWidth = A + "px",
                                l.style.minWidth = i + "px"
                            } else if ("left" == n) {
                                var A, x = 0;
                                (A = r - (r - (_ + E))) < i && (x = i - A),
                                l.style.right = -x + "px",
                                l.style.maxWidth = A + "px",
                                l.style.minWidth = i + "px"
                            }
                        } else if (O < r / 2)
                            (k = r - (r - (_ - u)) - a) < -20 && (k = 0),
                            l.style.left = -k + "px";
                        else
                            (x = r - (_ - u) - E - a) < -20 && (x = 0),
                            l.style.right = -x + "px";
                        if (c) {
                            --v;
                            var L = mmGetChildren(e, "ul.mm-submenu.tabbed>li>a>i.mm-arrow");
                            for (g = 0; g < L.length; g++)
                                L[g].classList.remove("mm-angle-left"),
                                L[g].classList.remove("mm-angle-down"),
                                L[g].classList.remove("mm-angle-right"),
                                L[g].classList.add("mm-angle-right");
                            e = e.querySelector("ul.mm-submenu.tabbed>li.tab-opened")
                        }
                        e && setSubmenuImageAndHeightBoundries(e, v),
                        disableOnScroll && setTimeout(mmStaticMenuFn, 100)
                    } else {
                        var C = e.closest(".vertical-mega-menu");
                        if (C) {
                            var I = C.offsetWidth;
                            I < r - 100 && (r = I),
                            c && (l.style.left = "auto",
                            l.style.right = "auto",
                            l.style.setProperty("width", "auto", "important"),
                            l.style.setProperty("height", "auto", "important"),
                            l.removeAttribute("columns"));
                            var T = mmForEach(e, ".mm-submenu.simple", (function(e) {
                                e.style.left = "auto",
                                e.style.right = "auto",
                                e.style.setProperty("width", "auto", "important"),
                                mmForEachChild(e, "LI", (function(e) {
                                    e.removeAttribute("style")
                                }
                                ))
                            }
                            ), !0);
                            v = 2;
                            if (o) {
                                var z = e.closest(".buddha-menu-item");
                                z && (v = null == (v = z.getAttribute("submenu-columns")) ? 4 : parseInt(v),
                                0 == c && null == e.closest("ul.mm-submenu.tabbed") || (mmForEach(e, 'ul.mm-submenu.simple>li[submenu-columns="' + (v - 1) + '"]', (function(e) {
                                    e.setAttribute("submenu-columns", 5)
                                }
                                )),
                                v++),
                                v > 1 && r < 360 ? v = 1 : v > 2 && r < 540 ? v = 2 : v > 3 && r < 720 ? v = 3 : v > 4 && r < 900 && (v = 4));
                                for (g = 0; g < T.length; g++)
                                    T[g].setAttribute("columns", v);
                                if (s)
                                    for (y = mmGetChildren(e, "ul.simple>li"),
                                    g = 0; g < y.length; g++) {
                                        S = y[g].getAttribute("submenu-columns"),
                                        w = y[g].getAttribute("submenu-original-columns");
                                        if (null != S && v < S)
                                            null == (w = y[g].getAttribute("submenu-original-columns")) && (y[g].setAttribute("submenu-original-columns", S),
                                            w = S),
                                            y[g].setAttribute("submenu-columns", v),
                                            S = v;
                                        null != w && v >= S && w > S && (y[g].setAttribute("submenu-columns", v),
                                        w == v && y[g].removeAttribute("submenu-original-columns"))
                                    }
                            } else {
                                var q = e.offsetWidth
                                  , N = 2;
                                q >= 540 ? v = 3 : q >= 360 ? v = 2 : (v = 1,
                                N = 1);
                                for (g = 0; g < T.length; g++)
                                    T[g].setAttribute("columns", v);
                                mmForEach(document, ".vertical-mega-menu ul.mm-submenu.mm-contact", (function(e) {
                                    e.setAttribute("columns", N)
                                }
                                ))
                            }
                            s && setSubmenuImageAndHeightBoundries(e, v)
                        }
                    }
                    setImagePlaceholderSize(l)
                } else if (l.matches(".tree")) {
                    var B = e.parentElement;
                    if (B && null == B.closest(".buddha-menu-item.mega-hover")) {
                        O = e.getBoundingClientRect().left + e.offsetWidth / 2;
                        var P = e.getAttribute("submenu-direction");
                        O < r / 2 && ("auto" == P || null == P) || "right" == P ? (mmForEach(e, "ul.mm-submenu.tree", (function(e) {
                            e.classList.remove("tree-open-left")
                        }
                        )),
                        mmForEach(e, "ul.mm-submenu.tree li>a>i.mm-arrow", (function(e) {
                            e.classList.remove("mm-angle-down"),
                            e.classList.remove("mm-angle-right"),
                            e.classList.remove("mm-angle-left"),
                            e.closest("li").querySelector(".mm-submenu") && e.classList.add("mm-angle-right")
                        }
                        ))) : (mmForEach(e, "ul.mm-submenu.tree", (function(e) {
                            e.classList.add("tree-open-left")
                        }
                        )),
                        mmForEach(e, "ul.mm-submenu.tree li>a>i.mm-arrow", (function(e) {
                            e.classList.remove("mm-angle-down"),
                            e.classList.remove("mm-angle-right"),
                            e.classList.remove("mm-angle-left"),
                            e.closest("li").querySelector(".mm-submenu") && e.classList.add("mm-angle-left")
                        }
                        )))
                    }
                }
            }
        } catch (e) {
            mmErrorLog(e)
        }
    }, setTabbedSubmenuBoundries = function(e) {
        try {
            if (e.closest(".horizontal-mega-menu")) {
                allowMainMenuRecalibration && setSubmenuBoundries(e.closest(".buddha-menu-item"));
                var t = e.querySelector(".mm-submenu:not(.hide-menu)");
                if (t) {
                    t.removeAttribute("style");
                    var n = t.offsetHeight
                      , m = 0;
                    mmForEachChild(e.parentElement, "LI", (function(e) {
                        m += e.offsetHeight
                    }
                    )),
                    m >= n ? (e.parentElement.style.setProperty("height", m + "px", "important"),
                    t.style.setProperty("height", m + "px", "important")) : e.parentElement.style.setProperty("height", n + "px", "important");
                    var o = e.offsetTop;
                    t.style.setProperty("top", "-" + o + "px", "important")
                } else
                    e.parentElement.style.setProperty("height", "auto")
            } else {
                var a = e.closest(".vertical-mega-menu");
                if (a) {
                    var i = a.querySelector(".tab-opened");
                    i && i.classList.remove("tab-opened"),
                    (t = e.querySelector(".mm-submenu:not(.hide-menu)")) && (t.style.removeProperty("top"),
                    t.style.removeProperty("height")),
                    e.parentElement.style.removeProperty("height")
                }
            }
        } catch (e) {
            mmErrorLog(e)
        }
    }, setContactSubmenuBoundries = function(e, t, n) {
        try {
            var m = window.innerWidth
              , o = 1e3
              , a = e.querySelector("ul.mm-submenu.mm-contact:not(.hide-menu)");
            if (a)
                if (e.closest(".horizontal-mega-menu")) {
                    for (var i, r = mmParents(e.parentElement), u = 0; u < r.length; u++) {
                        var l = parseInt(window.getComputedStyle(r[u]).getPropertyValue("padding-left"));
                        (p = r[u].getBoundingClientRect().left + l) < o && p > 0 && (o = p)
                    }
                    if ((1e3 == o || m <= 768) && (o = 0),
                    !t || void 0 === t)
                        (i = e.getAttribute("submenu-size")) && (t = i);
                    if (!n || void 0 === n)
                        (i = e.getAttribute("submenu-direction")) && (n = i);
                    customHeaderOffset ? o = customHeaderOffset < m ? (m - customHeaderOffset) / 2 : 0 : t && (o = t < m ? (m - t) / 2 : 0),
                    a.style.width = "auto",
                    a.style.left = "auto",
                    a.style.right = "auto",
                    a.style.maxWidth = "none",
                    a.style.minWidth = "auto",
                    a.style.maxHeight = "none",
                    2 * o > m && (o = 0);
                    var s = m - 2 * o;
                    ("left" == n || "right" == n) && m < 768 && (n = "auto");
                    var c = e.getBoundingClientRect()
                      , d = c.left
                      , g = c.width
                      , p = d + g / 2
                      , h = 768;
                    if (n && void 0 !== n && "auto" != n) {
                        if ("right" == n) {
                            l = parseInt(window.getComputedStyle(e).getPropertyValue("padding-left")),
                            f = 0;
                            (b = m - (d + l)) < h && (f = h - b),
                            s > b && (s = b),
                            a.style.left = -f + "px",
                            a.style.width = s + "px",
                            a.style.maxWidth = b + "px",
                            a.style.minWidth = h + "px"
                        } else if ("left" == n) {
                            var b;
                            v = 0;
                            (b = m - (m - (d + g))) < h && (v = h - b),
                            s > b && (s = b),
                            a.style.right = -v + "px",
                            a.style.width = s + "px",
                            a.style.maxWidth = b + "px",
                            a.style.minWidth = h + "px"
                        }
                    } else {
                        var f, v;
                        if (p < m / 2)
                            (f = m - (m - d) - o) < -20 && (f = 0),
                            a.style.left = -f + "px";
                        else
                            (v = m - d - g - o) < -20 && (v = 0),
                            a.style.right = -v + "px";
                        a.style.width = s + "px",
                        a.style.minWidth = h + "px"
                    }
                } else
                    a.style.left = "auto",
                    a.style.right = "auto",
                    a.style.width = "auto",
                    a.style.height = "auto",
                    a.style.minWidth = "auto",
                    a.style.maxWidth = "none",
                    a.offsetWidth <= 480 && a.classList.add("one-column")
        } catch (e) {
            mmErrorLog(e)
        }
    }, mmTouchMoved = !1, mmTouchOnce = !1, mmEvtTouchStart = function(e) {
        mmTouchMoved = !1
    }, mmEvtTouchMove = function(e) {
        mmTouchMoved = !0
    }, mmEvtTouchEnd = function(e) {
        var t = e.target;
        setTimeout((function() {
            mmTouchMoved = !1,
            mmTouchOnce = !1
        }
        ), 300);
        try {
            if (0 == mmTouchOnce && 0 == mmTouchMoved)
                if (mmTouchOnce = !0,
                null != t.closest(".vertical-mega-menu li")) {
                    if (m = t.closest("li")) {
                        var n = m.querySelector("a>.toggle-menu-btn");
                        n || (n = m.querySelector("a>span>.toggle-menu-btn")),
                        n ? m.classList.contains("mm-hovering") && null == t.closest(".toggle-menu-btn") || (e.preventDefault(),
                        e.stopPropagation(),
                        toggleSubmenu(n)) : null != t.closest(".buddha-menu-item") && (null != m.closest(".buddha-menu-item-countdown") ? e.preventDefault() : m.matches("li[item-type='link-list']") && null == m.querySelector(".mm-list-name span[onclick]") ? (e.preventDefault(),
                        e.stopPropagation()) : null != m.closest(".mm-contact") || null == t.closest(".mm-add-to-cart") && setTimeout((function() {
                            if (!changingPage) {
                                var e = m.querySelector("a");
                                e && e.click()
                            }
                        }
                        ), 200))
                    }
                } else if (null != t.closest(".horizontal-mega-menu li")) {
                    var m;
                    if (m = t.closest("li"))
                        if (m.matches(".buddha-menu-item"))
                            if (m.classList.contains("mega-hover") || null == m.querySelector("ul.mm-submenu")) {
                                (l = m.querySelector("a")) && mmGoToPage(l, e)
                            } else {
                                e.preventDefault(),
                                e.stopPropagation(),
                                mmForEach(document, ".mega-hover", (function(e) {
                                    e.classList.remove("mega-hover")
                                }
                                )),
                                m.classList.add("mega-hover"),
                                setSubmenuBoundries(m),
                                setContactSubmenuBoundries(m);
                                var o = m.querySelector(".tab-opened");
                                o && setTabbedSubmenuBoundries(o)
                            }
                        else if (m.parentNode.matches(".mm-submenu.tabbed")) {
                            if (null != m.querySelector("ul.mm-submenu"))
                                if (m.classList.contains("tab-opened"))
                                    (l = m.querySelector("a")) && mmGoToPage(l, e);
                                else
                                    e.preventDefault(),
                                    e.stopPropagation(),
                                    mmForEachChild(m.parentNode, "LI", (function(e) {
                                        e.classList.remove("tab-opened")
                                    }
                                    )),
                                    m.classList.add("tab-opened"),
                                    setTabbedSubmenuBoundries(m),
                                    setSubmenuBoundries(m.parentNode.parentNode)
                        } else if (null != m.closest(".mm-submenu.tree") && null != m.querySelector("ul.mm-submenu"))
                            if (m.classList.contains("mega-hover")) {
                                (l = m.querySelector("a")) && mmGoToPage(l, e)
                            } else {
                                e.preventDefault(),
                                e.stopPropagation(),
                                mmForEachChild(m.parentNode, "LI", (function(e) {
                                    e.classList.remove("mega-hover")
                                }
                                )),
                                mmForEach(m, ".mega-hover", (function(e) {
                                    e.classList.remove("mega-hover")
                                }
                                )),
                                m.classList.add("mega-hover");
                                for (var a = mmParents(m, "LI"), i = 0; i < a.length; i++)
                                    a[i].classList.add("mega-hover");
                                setSubmenuBoundries(m)
                            }
                        else if (null != m.closest(".buddha-menu-item-countdown"))
                            e.preventDefault();
                        else if (null != m.closest(".mm-contact"))
                            e.preventDefault(),
                            e.stopPropagation();
                        else if (null == t.closest(".mm-add-to-cart")) {
                            var r = t.closest(".mm-list-name");
                            if (r) {
                                var u = r.querySelector("span[onclick]");
                                u && mmGoToPage(u, e)
                            } else {
                                var l;
                                (l = m.querySelector("a")) && mmGoToPage(l, e)
                            }
                        }
                }
        } catch (e) {
            mmErrorLog(e)
        }
    }, mmEvtTouchEndGlobal = function(e) {
        var t = e.target;
        globalTouch && null == t.closest(".buddha-menu-item") && mmForEach(document, ".mega-hover", (function(e) {
            e.classList.remove("mega-hover")
        }
        ))
    }, addTouch = function() {
        document.removeEventListener("touchend", mmEvtTouchEndGlobal),
        document.addEventListener("touchend", mmEvtTouchEndGlobal);
        for (var e = 0; e < mmMenuUls.length; e++) {
            var t = mmMenuUls[e];
            t && (t.removeEventListener("touchstart", mmEvtTouchStart),
            t.addEventListener("touchstart", mmEvtTouchStart, !!mmSupportsPassive && {
                passive: !0
            }),
            t.removeEventListener("touchmove", mmEvtTouchMove),
            t.addEventListener("touchmove", mmEvtTouchMove, !!mmSupportsPassive && {
                passive: !0
            }),
            t.removeEventListener("touchend", mmEvtTouchEnd),
            t.addEventListener("touchend", mmEvtTouchEnd))
        }
    }, getBrightness = function(e) {
        var t = parseInt(e.substring(1), 16);
        return .2126 * (t >> 16 & 255) + .7152 * (t >> 8 & 255) + .0722 * (t >> 0 & 255)
    }, LightenDarkenColor = function(e, t) {
        var n = !1;
        "#" == e[0] && (e = e.slice(1),
        n = !0);
        var m = parseInt(e, 16)
          , o = (m >> 16) + t;
        o > 255 ? o = 255 : o < 0 && (o = 0);
        var a = (m >> 8 & 255) + t;
        a > 255 ? a = 255 : a < 0 && (a = 0);
        var i = (255 & m) + t;
        return i > 255 ? i = 255 : i < 0 && (i = 0),
        (n ? "#" : "") + String("000000" + (i | a << 8 | o << 16).toString(16)).slice(-6)
    }, preloadBuddhaMegaMenu = function() {
        "undefined" != typeof mmCustomerFixesBeforeLoad && mmCustomerFixesBeforeLoad(),
        "function" == typeof jQueryBuddha && ("undefined" != typeof loadFlipClockBuddha && loadFlipClockBuddha(jQueryBuddha),
        "undefined" != typeof loadLivIconsBuddha && loadLivIconsBuddha(jQueryBuddha)),
        void 0 !== loadBuddhaMegaMenu ? loadBuddhaMegaMenu() : setTimeout((function() {
            loadBuddhaMegaMenu()
        }
        ), 1e3)
    }, loadJqueryBuddha = function() {
        var xhr = new XMLHttpRequest;
        xhr.onreadystatechange = function() {
            var done = void 0 !== XMLHttpRequest.DONE ? XMLHttpRequest.DONE : 4;
            if (xhr.readyState == done) {
                var data = xhr.responseText;
                window.jQueryBuddha = data.replace(/jQuery/g, "jQueryBuddha"),
                eval(jQueryBuddha),
                "undefined" != typeof jQuery && void 0 !== jQuery.noConflict && ($ = jQuery.noConflict()),
                preloadBuddhaMegaMenu()
            }
        }
        ,
        xhr.open("GET", "https://code.jquery.com/jquery-3.5.1.slim.min.js", !0),
        xhr.send(null)
    }, BuddhaMegaMenuMain = function() {
        if ("undefined" != typeof linkLists && 0 == mmLivIcons && 0 == mmFlipClock && 0 == mmFixesUseJquery)
            preloadBuddhaMegaMenu();
        else if ("undefined" == typeof jQuery || "undefined" != typeof jQuery && (null == jQuery || null != jQuery && (void 0 === jQuery.fn || void 0 !== jQuery.fn && void 0 === jQuery.fn.jquery)))
            loadJqueryBuddha();
        else {
            var e = jQuery.fn.jquery.split(".");
            1 == parseInt(e[0]) && parseInt(e[1]) >= 7 || parseInt(e[0]) > 1 ? (window.jQueryBuddha = jQuery,
            preloadBuddhaMegaMenu()) : loadJqueryBuddha()
        }
    };
    if (window.self === window.top)
        BuddhaMegaMenuMain();
    else if ("loading" !== document.readyState)
        BuddhaMegaMenuMain();
    else {
        var mmAppLoaded = !1;
        document.addEventListener("DOMContentLoaded", (function() {
            0 == mmAppLoaded && (mmAppLoaded = !0,
            BuddhaMegaMenuMain())
        }
        )),
        setTimeout((function() {
            document.removeEventListener("DOMContentLoaded", BuddhaMegaMenuMain),
            0 == mmAppLoaded && (mmAppLoaded = !0,
            BuddhaMegaMenuMain())
        }
        ), 15e3)
    }
}
